import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      "hello": "Hello! Let's get started",
      "sign_in_continue": "Sign in to continue.",
      "email": "Email",
      "password": "Password",
      "keep_me_signed_in": "Keep me signed in",
      "forgot_password": "Forgot password?",
      "sign_in": "SIGN IN",
      "login_btn": "LOGIN",
      "dont_have_account": "Don't have an account?",
      "create_account": "Create",
      "logout": "Logout",
      "welcome_back": "Welcome back!",
      "happy_see_you": "Happy to see you again!",
      "profile": "Profile",
      "activity_log": "Activity Log",
      "language": "Language",
      "new_here": "New here?",
      "join_us_today": "Join us today! It takes only few steps",
      "username": "Username",
      "country": "Country",
      "sign_up": "SIGN UP",
      "already_have_account": "Already have an account?",
      "agree_terms": "I agree to all Terms & Conditions",
      "agree_terms_required": "You must accept the Terms and Conditions to register.",
      "register_success_redirect": "Registration successful! Redirecting to login...",
      "search_placeholder": "Search projects, orders, or customers...",
      "notifications": "Notifications",
      "see_all_notifications": "See all notifications",
      "mark_all_read": "Mark all as read",
      "no_notifications": "No new notifications",
      "loading": "Loading...",
      "btn_confirm": "Confirm",
      "btn_close": "Close",
      "btn_actions": "Actions",
      "success": "Success",
      "error": "Error",
      "warning": "Warning",
      "info": "Info",
      "menu_dashboard": "Dashboard",
      "menu_sales_catalog": "Sales & Catalogue",
      "menu_seller_analytics": "Seller Analytics & Performance",
      "seller_analytics_title": "Seller Performance & Commercial Analytics",
      "seller_analytics_subtitle": "Executive dashboard for sales tracking, collection efficiency, early-payment commissions, and revenue targets.",
      "seller_analytics_config_tiers": "Configure Commissions",
      "seller_analytics_assign_targets": "Assign Targets",
      "seller_analytics_refresh_data": "Refresh Data",
      "seller_analytics_filter_period": "Period:",
      "seller_analytics_period_current_month": "Current Month",
      "seller_analytics_period_last_month": "Previous Month",
      "seller_analytics_period_current_week": "Current Week",
      "seller_analytics_period_last_week": "Previous Week",
      "seller_analytics_period_custom": "Custom Range",
      "seller_analytics_filter_from": "From",
      "seller_analytics_filter_to": "To",
      "seller_analytics_filter_seller": "Seller:",
      "seller_analytics_all_sellers": "All Sellers",
      "seller_analytics_filter_zone": "Zone:",
      "seller_analytics_all_zones": "All Zones",
      "seller_analytics_clear_filters": "Clear Filters",
      "seller_analytics_kpi_sales": "Total Invoiced Sales",
      "seller_analytics_kpi_orders_billed": "invoiced orders",
      "seller_analytics_kpi_avg_ticket": "Average Ticket",
      "seller_analytics_kpi_per_order": "per closed order",
      "seller_analytics_kpi_effective_collection": "Effective Collection",
      "seller_analytics_kpi_paid_of": "paid out of",
      "seller_analytics_kpi_total": "total",
      "seller_analytics_kpi_collection_rate": "Collection Rate",
      "seller_analytics_kpi_of_total_sold": "of total amount sold",
      "seller_analytics_kpi_pending_collection": "Pending Collection",
      "seller_analytics_kpi_overdue": "Overdue:",
      "seller_analytics_kpi_invoices_pending": "pending invoices",
      "seller_analytics_kpi_commissions": "Commissions Earned",
      "seller_analytics_kpi_commissions_sub": "for collection promptness",
      "seller_analytics_chart_comparison": "Invoicing & Collection Comparison by Seller",
      "seller_analytics_total_sold_label": "Total Sold ($)",
      "seller_analytics_total_collected_label": "Total Collected ($)",
      "seller_analytics_tiers_distribution": "Distribution by Collection Tier",
      "seller_analytics_commission_label": "Commission:",
      "seller_analytics_ranking_title": "Sellers Commercial Performance & Ranking",
      "seller_analytics_ranking_subtitle": "Detailed comparison of billing, collection effectiveness, earned commissions, and target completion.",
      "seller_analytics_search_placeholder": "Search seller or zone...",
      "seller_analytics_th_seller": "Seller",
      "seller_analytics_th_sold": "Total Sold ($)",
      "seller_analytics_th_collected": "Collected ($)",
      "seller_analytics_th_pending": "Pending ($)",
      "seller_analytics_th_target_progress": "Target Progress",
      "seller_analytics_th_commission": "Commission Earned ($)",
      "seller_analytics_th_actions": "Actions",
      "seller_analytics_no_zone": "No zone",
      "seller_analytics_orders_count": "orders",
      "seller_analytics_collected_count": "collected",
      "seller_analytics_meta_label": "Target:",
      "seller_analytics_no_target_badge": "No target set",
      "seller_analytics_bonus_payments": "bonus payments",
      "seller_analytics_view_breakdown": "View commission and tiers breakdown",
      "seller_analytics_assign_target": "Assign or edit commercial target",
      "seller_analytics_no_sellers_found": "No sellers found matching the selected filters",
      "seller_analytics_modal_tiers_title": "Collection Commission Tiers Configuration",
      "seller_analytics_modal_tiers_desc": "Commission percentages are fully self-managed. The incentive rewards payment speed based on elapsed days from order delivery to payment registration.",
      "seller_analytics_modal_th_tier_name": "Tier Name",
      "seller_analytics_modal_th_days_from": "Days From",
      "seller_analytics_modal_th_days_to": "Days To",
      "seller_analytics_modal_th_commission_pct": "Commission (%)",
      "seller_analytics_modal_th_status": "Status",
      "seller_analytics_modal_no_limit": "No limit",
      "seller_analytics_modal_auto_logic_title": "Automatic Calculation Logic",
      "seller_analytics_modal_auto_logic_desc": "When a payment is validated in the system, the API calculates the elapsed days from delivery date to payment confirmation, automatically matching the appropriate tier and granting the configured percentage.",
      "seller_analytics_save_config": "Save Configuration",
      "seller_analytics_modal_target_title": "Assign Commercial Target",
      "seller_analytics_modal_field_seller": "Seller",
      "seller_analytics_modal_select_seller": "Select a seller...",
      "seller_analytics_modal_field_period_type": "Period Type",
      "seller_analytics_period_monthly": "Monthly",
      "seller_analytics_period_weekly": "Weekly",
      "seller_analytics_field_start_date": "Start Date",
      "seller_analytics_field_end_date": "End Date",
      "seller_analytics_field_target_amount": "Revenue Target ($ USD)",
      "seller_analytics_target_help": "This target will be displayed in real-time in the seller mobile app.",
      "seller_analytics_btn_save_target": "Assign Target",
      "seller_analytics_saving_target": "Saving target...",
      "seller_analytics_modal_breakdown_title": "Commercial Breakdown:",
      "seller_analytics_modal_total_sales": "Total Sales",
      "seller_analytics_modal_total_collected": "Total Collected",
      "seller_analytics_modal_pending": "Pending",
      "seller_analytics_modal_commissions_won": "Commissions Earned",
      "seller_analytics_modal_breakdown_subtitle": "Commission Breakdown by Days Tier",
      "seller_analytics_modal_th_tier_col": "Collection Tier",
      "seller_analytics_modal_th_pct_col": "Percentage (%)",
      "seller_analytics_modal_th_payments_col": "Registered Payments",
      "seller_analytics_modal_th_collected_amount": "Amount Collected ($)",
      "seller_analytics_modal_th_earned_commission": "Commission Earned ($)",
      "seller_analytics_invoices_count": "invoices",
      "seller_analytics_error_load": "Could not load commercial dashboard data",
      "seller_analytics_tiers_saved_success": "Commission tiers and percentages updated successfully",
      "seller_analytics_tiers_saved_error": "Error saving commission tiers",
      "seller_analytics_select_seller_warning": "Please select a seller",
      "seller_analytics_valid_amount_warning": "Please enter a valid dollar target amount",
      "seller_analytics_target_saved_success": "Commercial target assigned successfully",
      "seller_analytics_target_saved_error": "Error assigning commercial target",
      "seller_analytics_chart_comparison_sub": "Comparison of billed volume versus collected funds",
      "seller_analytics_chart_no_data": "Not enough sales data to graph in this period",
      "seller_analytics_tiers_sub": "Tiered incentive based on recovery speed",
      "seller_analytics_tiers_empty": "No collections recorded in tiers",
      "seller_analytics_loading": "Consolidating commercial metrics...",
      "seller_analytics_active_sellers": "sellers",
      "seller_analytics_kpi_dso_avg": "Average DSO:",
      "seller_analytics_kpi_up_to_date": "Up to date",
      "seller_analytics_period_today": "Today",
      "menu_media_gallery": "Media Gallery",
      "menu_clients_logistics": "Clients & Logistics",
      "menu_clients": "Customers",
      "menu_zones_territories": "Zones & Territories",
      "menu_route_planner": "Route Planner",
      "menu_dispatch_manager": "Dispatch Manager",
      "menu_staff_control": "Staff & Governance",
      "menu_my_profile": "My Profile",
      "menu_staff_roles": "Staff & Roles",
      "menu_master_data": "Master Data",
      "menu_faqs": "FAQ & Help Center",
      "copyright_text": "All rights reserved.",
      "system_tagline": "Rutex System • Enterprise Distribution Platform",
      "system_version_title": "Commercial Management System v{{version}} by Alpinca & Lácteos Danny",
      "role_superadmin": "Super Administrator",
      "role_admin": "Administrator",
      "role_seller": "Seller / Commercial",
      "role_salesapp": "Sales App",
      "role_auditor": "Commercial Auditor",
      "role_warehouse": "Warehouse Operator",
      "role_driver": "Delivery Driver",
      "role_customer": "Customer",
      "role_merchandiser": "Merchandiser",
      "role_supervisor": "Supervisor",
      "orders_console_title": "Sales, Weighing & Logistics Control Console",
      "tab_pending": "1. Pending for Weighing",
      "tab_weighing": "2. In Warehouse Weighing",
      "tab_history": "3. History & Billing",
      "btn_consolidate": "Consolidate",
      "btn_consolidate_print": "Consolidate & Print",
      "tooltip_select_orders_to_consolidate": "Select one or more orders in the table to consolidate",
      "tooltip_consolidate_single": "Consolidate and generate weighing sheet for this order",
      "tooltip_order_already_selected": "This order is included in batch selection. Use the top 'Consolidate & Print' button",
      "btn_detail": "Detail",
      "btn_real_kilos": "Real Weights",
      "btn_print_sheet": "Weighing Sheet",
      "btn_approve_payment": "Approve Payment",
      "btn_dispatch": "Dispatch",
      "btn_voucher": "Voucher",
      "btn_mark_delivered": "Mark as Delivered",
      "tooltip_view_voucher": "View attached payment voucher",
      "tooltip_proforma_pdf": "View / Download Proforma Invoice PDF",
      "status_in_dispatch": "In Dispatch",
      "status_in_weighing": "In Weighing",
      "status_invoiced": "Invoiced",
      "status_delivered": "Delivered",
      "status_completed": "Completed",
      "status_dispatched": "Dispatched",
      "status_cancelled": "Cancelled",
      "status_for_payment": "To Pay",
      "status_in_verification": "In Verification",
      "status_approved": "Approved",
      "status_rejected": "Rejected",
      "status_expired": "Expired",
      "status_annulled": "Annulled",
      "status_not_enabled": "Not Enabled",
      "modal_order_detail": "Order Details",
      "modal_weighing_title": "Load Real Scale Weights",
      "timeline_title": "Audit Status Traceability History",
      "customers_title": "Customer Management",
      "btn_import_excel": "Import Excel",
      "btn_preload_manual": "Manual Pre-load",
      "search_customer_placeholder": "Search by RIF, Trade Name or Email...",
      "status_all": "All Statuses",
      "status_inactive": "Inactive",
      "status_pending_approval": "Pending Audit",
      "status_requires_visit": "Requires Field Visit",
      "status_active": "Active",
      "status_disabled": "Disabled / Blocked",
      "status_rejected": "Rejected / Not Approved",
      "th_rif": "RIF / ID Tax Number",
      "th_razon_social": "Trade Name",
      "th_category": "Category",
      "th_credit_limit": "Credit Limit ($)",
      "th_status": "Status",
      "th_actions": "Actions",
      "btn_approve": "Approve",
      "btn_block": "Block",
      "btn_unblock": "Unblock",
      "no_customers_found": "No customers found.",
      "modal_edit_customer": "Edit Customer",
      "modal_new_customers": "Load New Customers",
      "tab_manual_creation": "Manual Creation",
      "tab_bulk_import": "Bulk Import",
      "manual_alert_notice": "This customer will be registered as Invited / No Password (inactive). Upon entering their RIF in the Mobile App, they can quickly activate their account by creating a password without requiring additional approval.",
      "import_alert_notice": "Upload an Excel (.xlsx or .csv) file exported from your ERP. All customers will be loaded as Invited / No Password (inactive). Upon entering their RIF in the Mobile App, their account will be directly activated.",
      "field_rif": "RIF or Tax ID",
      "field_razon_social": "Trade Name",
      "field_phone": "Phone",
      "field_billing_email": "Billing Email",
      "field_address": "Physical Address",
      "field_category": "Category",
      "field_credit_limit": "Credit Limit ($)",
      "field_assigned_seller": "Assigned Seller",
      "select_option": "Select...",
      "no_seller": "No Seller",
      "field_documents": "Attached Documents / Images (RIF, Tax ID, Registry - Optional)",
      "documents_help": "Supported formats: PDF, JPG, PNG (max. 10MB). You can select multiple files or add them one by one.",
      "add_more_documents": "Attach New Documents (Optional)",
      "select_documents": "Select Documents",
      "add_more_documents_btn": "Add More Documents",
      "clear_all_files": "Deselect All",
      "selected_files_count": "Selected Files",
      "drop_file_label": "Select your database file",
      "browse_files": "Browse Files",
      "expected_format": "Expected format: The file must contain at least the columns rif, razon_social, direccion, and vendedor_asignado (seller name or email).",
      "modal_approve_title": "Approve Customer",
      "approve_description": "You are about to approve this registration. The user account will be activated to access the Mobile App.",
      "assign_credit_limit": "Assign Credit Limit ($)",
      "credit_limit_help": "You can enter 0 if no initial credit will be granted.",
      "btn_confirm_approval": "Confirm Approval",
      "btn_cancel": "Cancel",
      "btn_save_changes": "Save Changes",
      "btn_save_customer": "Save Customer",
      "btn_start_import": "Start Import",
      "btn_create_customer": "Create Customers",
      "total_customers_kpi": "Total Customers",
      "th_assigned_vendor": "Assigned Seller",
      "btn_inspect": "Inspect",
      "btn_visit_inspection": "Visit / Inspection",
      "btn_addresses_gps": "Addresses & GPS",
      "btn_edit": "Edit",
      "btn_reject_request": "Reject Request",
      "btn_request_vendor_visit": "Request Vendor Visit",
      "btn_approve_commercial_account": "Approve Commercial Account",
      "btn_edit_customer_data": "Edit Customer Data",
      "assign_field_visit_title": "Assign Field Visit to Vendor",
      "visit_status_notice": "Upon saving, the status will change to Requires Field Visit and a task will be automatically created for the assigned vendor.",
      "field_assigned_seller_required": "Assigned Vendor *",
      "select_vendor_placeholder": "-- Select Vendor --",
      "select_zone_placeholder": "-- Select Zone --",
      "field_instructions_vendor": "Notes or Instructions for Vendor",
      "btn_create_visit_task": "Create Visit Task",
      "field_initial_credit_limit": "Initial Credit Limit ($) *",
      "reject_request_title": "Reject Commercial Request",
      "field_rejection_reason": "Rejection Reason *",
      "btn_confirm_rejection": "Confirm Rejection",
      "out_of_zone_title": "Location Outside Active Commercial Zones",
      "out_of_zone_msg": "The GPS coordinates registered by the customer do not fall within any active geofence, so they do not have an assigned territorial vendor yet. If you wish to assign a field visit, please expand the corresponding zone polygon in Zone Management first.",
      "field_visit_in_progress": "Commercial Field Visit in Progress",
      "seller_notified": "Assigned Vendor Notified:",
      "territorial_zone": "Territorial Zone:",
      "instructions_sent": "Instructions sent:",
      "field_verification_report_title": "Commercial Field Visit Report",
      "badge_validated_by_seller": "VALIDATED BY VENDOR",
      "badge_observed_rejection": "OBSERVED / REJECTION REASONS",
      "inspected_by": "Inspected by:",
      "physical_confirmation_note": "Physical confirmation: The vendor verified on site that the establishment exists, is operational, and meets commercial terms.",
      "rejection_reasons_in_field": "Rejection reasons reported in the field:",
      "no_specific_reasons": "No specific reasons detailed.",
      "seller_observations": "Vendor Observations:",
      "view_gps_capture_point": "View GPS capture location",
      "facade_photo_title": "Commercial Facade Evidence",
      "expand_photo": "Enlarge Photo",
      "zoom_facade_title": "Commercial Facade",
      "rows_per_page": "Rows per page:",
      "of_range": "of",
      "all_items": "All",
      "unassigned": "Unassigned",
      "inventory_management": "Inventory Management",
      "stock_out_of_stock": "Out of Stock (0)",
      "stock_hidden_in_app": "Hidden in App",
      "stock_low": "Low",
      "units_per_box_badge": "u/box",
      "no_category": "No Category",
      "price_a_label": "Price A (Invoice)",
      "price_b_label": "Price B (Receipt)",
      "reserved_stock": "Reserved",
      "real_stock": "Real Stock",
      "btn_deactivate": "Deactivate",
      "filters_and_search": "Filters & Search",
      "th_img": "Img",
      "th_name": "Name",
      "max_stock_reached": "For now, we can only supply {{count}}",
      "cart_reserved_success": "Product added to cart and stock reserved",
      "search_product_label": "Search Product",
      "search_product_placeholder": "Search by Name or SKU...",
      "status_active_in_catalog": "Active (In catalogue)",
      "status_inactive_disabled": "Inactive (Deactivated)",
      "all_categories": "All Categories",
      "products_and_stock": "Products & Stock",
      "no_products_in_inventory": "No products in inventory.",
      "modal_create_product": "Create New Product",
      "modal_edit_product": "Edit Product",
      "step_select_category": "1. Select Category",
      "choose_category_placeholder": "Select Category",
      "field_unit_measure": "Unit of Measure",
      "field_sku": "SKU (Code)",
      "field_product_name": "Product Name",
      "field_price_usd": "Price USD ($)",
      "field_units_per_box": "Units per Box / Package",
      "field_physical_stock": "Physical Stock",
      "field_min_stock": "Minimum Stock",
      "field_reserved_stock": "Reserved",
      "field_product_image": "Product Image",
      "btn_select_gallery": "Select from Gallery",
      "btn_change_gallery": "Change Image from Gallery",
      "btn_remove_image": "Remove",
      "field_description": "Description",
      "modal_import_products_title": "Bulk Product Import",
      "import_csv_instructions": "The CSV file must contain the following comma-separated columns in this exact order:",
      "select_inventory_file": "Select your inventory file",
      "btn_browse_files": "Browse Files",
      "file_selected_label": "{{name}} selected",
      "btn_upload_import": "Upload & Import",
      "modal_gallery_select_title": "Select Image from Gallery",
      "gallery_select_subtitle": "Click on the image you want to assign to this product",
      "search_file_placeholder": "Search by file name...",
      "btn_upload_new_image": "Upload New Image",
      "uploading_label": "Uploading...",
      "loading_media_gallery": "Loading media gallery...",
      "querying_server_images": "Querying images from central Rutex server",
      "no_images_found_gallery": "No images found in gallery.",
      "no_images_in_gallery_system": "No images uploaded in system gallery yet.",
      "assigned_label": "Assigned",
      "tab_for_approval": "0. Pending Approval (Proforma)",
      "btn_approve_proforma": "Approve & Generate Proforma",
      "btn_reject_order": "Reject / Adjust Order",
      "btn_view_proforma_pdf": "View Proforma PDF",
      "modal_proforma_title": "Review & Virtual Proforma Invoice Generation",
      "modal_reject_title": "Order Rejection & Stock Release",
      "bcv_rate_badge": "Official BCV Rate of the Day:",
      "bcv_rate_loading": "Loading rate...",
      "bcv_rate_unavailable": "Rate unavailable",
      "stock_release_warning": "Notice: Rejecting this order will automatically return reserved physical inventory to general stock.",
      "general_search": "General Search",
      "search_order_placeholder": "Search by Order #, RIF or Customer...",
      "filter_by_zone": "Filter by Zone",
      "all_zones": "All Zones",
      "date_range": "Date Range",
      "tab_proforma_header": "Orders Pending Commercial Approval (Proforma)",
      "tab_pending_header": "Approved Orders Pending Weighing",
      "tab_weighing_header": "Orders in Weighing & Scale Process",
      "tab_history_header": "Orders History, Billing & Collections",
      "th_zone": "Zone",
      "th_estimated_total": "Estimated Total",
      "th_real_total": "Real Total",
      "th_order_status": "Order Status",
      "th_invoice_status": "Invoice Status",
      "no_zone": "No Zone",
      "no_orders_pending_weighing": "No approved orders pending weighing in inbox.",
      "no_orders_in_history": "No orders found in history matching these criteria.",
      "btn_confirm_reject": "Confirm Rejection & Release Stock",
      "btn_confirm_weighing": "Confirm Weighing & Recalculate Final Total",
      "customer_info": "Customer Information",
      "order_status": "Order Status",
      "products_in_order": "Products in Order",
      "field_payment_terms": "Payment Terms",
      "failed_load_order_info": "Could not load order information.",
      "editable_products_table": "Editable Products Table (Real Quantity & Price Adjustment)",
      "subtotal_base_usd": "Base Subtotal USD:",
      "iva_usd": "VAT (16%) USD:",
      "total_referential_usd": "TOTAL REFERENTIAL USD ($):",
      "th_requested_qty": "Requested Qty",
      "th_weighed_qty": "Weighed Qty",
      "th_real_qty_scale": "Real Qty (Scale)",
      "th_unit_price": "Unit Price ($)",
      "th_subtotal": "Subtotal ($)",
      "th_unit": "Unit",
      "dashboard_title": "Operator Console",
      "dashboard_subtitle": "Real-time summary of sales, weighing, and routes.",
      "reload_data": "Reload Data",
      "pending_weighing": "To Weigh",
      "pending_weighing_desc": "Orders awaiting scale in warehouse",
      "pending_payment": "Pending Payment",
      "pending_payment_desc": "Weighed orders awaiting payment/approval",
      "kpi_total_sales": "Total Sales",
      "total_sales_desc": "Total invoiced amount (excluding cancelled)",
      "ready_dispatched": "Ready / Dispatched",
      "ready_dispatched_desc": "Consolidated orders ready for route",
      "orders_count_label": "orders",
      "weekly_sales_by_day": "Weekly Sales by Day",
      "weekly_sales_desc": "Accumulated amounts of active weighed orders in warehouse.",
      "operation_status": "Operation Status",
      "operation_status_desc": "Percentage distribution of orders in workflow.",
      "status_pending_weighing_upper": "PENDING WEIGHING",
      "status_pending_payment_upper": "PENDING PAYMENT / ON HOLD",
      "status_ready_dispatched_upper": "READY FOR DISPATCH / ON ROUTE",
      "sales_by_day_dataset": "Sales by Day ($)",
      "recent_orders": "Recent Orders History",
      "final_consumer": "Final Consumer",
      "direct_sale": "Direct Sale",
      "no_recent_orders": "No recent orders registered.",
      "pending_tasks": "Pending Tasks",
      "log_scale_calibrated": "Warehouse scale calibrated successfully.",
      "log_route_sheet": "Loading Sheet generated for Northern Route.",
      "log_inventory_update": "Bulk inventory update completed.",
      "kpi_active_orders": "Active Orders in Flow",
      "kpi_registered_customers": "Registered Customers",
      "kpi_pending_kyc": "Pending KYC Approvals",
      "chart_sales_performance": "Sales Performance (USD)",
      "chart_top_products": "Top Selling Products",
      "th_order_id": "Order #",
      "th_customer": "Customer",
      "th_amount": "Amount ($)",
      "th_date": "Date",
      "quick_actions": "Quick Actions",
      "btn_new_order": "New Order",
      "btn_add_product": "Add Product",
      "btn_register_client": "Register Client",
      "zones_territories_title": "Zones & Territories",
      "btn_new_zone": "New Zone",
      "search_zone_placeholder": "Search by zone name or code...",
      "th_zone_code": "Code",
      "th_zone_name": "Zone Name",
      "modal_new_zone": "New Distribution Zone",
      "modal_edit_zone": "Edit Distribution Zone",
      "geographic_area_map": "Geographic Area (Map)",
      "undo_point": "Undo Point",
      "clear_map": "Clear Map",
      "btn_save_zone": "Save Zone",
      "route_planner_title": "Route Planner (Agenda)",
      "menu_agenda_monitor": "Route Schedule",
      "menu_merchandising_reports": "Shelf Audit & Merchandising",
      "merchandising_reports_title": "Shelf Audit & Trade Marketing",
      "merchandising_reports_subtitle": "Supervision of shelf displays, before/after photos, store inventory, competitor prices and POP material.",
      "view_gallery": "Gallery",
      "view_table": "Table",
      "kpi_total_audits": "Audits",
      "kpi_total_audits_hint": "Received reports",
      "kpi_audited_pdvs": "Audited Stores",
      "kpi_audited_pdvs_hint": "Unique points of sale",
      "kpi_stock_alerts": "Out of Stock",
      "kpi_stock_alerts_hint": "Reported stockouts",
      "kpi_pop_good_condition": "Displays OK",
      "kpi_pop_good_condition_hint": "POP material in good condition",
      "kpi_photo_coverage": "Photo Coverage",
      "kpi_photo_coverage_hint": "With photos registered",
      "filter_from": "From",
      "filter_to": "To",
      "filter_merchandiser": "Merchandiser",
      "all_merchandisers": "All Merchandisers",
      "filter_zone": "Zone",
      "search_pdv_rif": "Search POS / Tax ID",
      "search_merchandising_placeholder": "Search POS, Tax ID, merchandiser or route...",
      "clear_filters": "Clear filters",
      "reset_filters": "Reset filters",
      "loading_reports": "Loading shelf audits...",
      "no_reports_found": "No audits found",
      "no_reports_found_hint": "No merchandiser reports match the selected filters.",
      "pop_no_data": "No POP Data",
      "pop_ok": "Display OK",
      "pop_damaged": "Display Damaged",
      "pop_none": "No Display",
      "unknown_client": "Point of Sale",
      "label_initial_inventory": "In-Store Stock:",
      "label_out_of_stock": "Stockouts / Depleted:",
      "out_of_stock_tag": "out of stock",
      "zero_out_of_stock": "0 stockouts",
      "view_full_audit": "View Full Audit",
      "photo_before": "BEFORE",
      "photo_after": "AFTER",
      "no_photo_before": "No prior photo",
      "no_photo_after": "No post photo",
      "btn_zoom": "Zoom",
      "zoom_view": "Zoom View",
      "th_datetime": "Date / Time",
      "th_pdv": "Point of Sale (POS)",
      "th_zone": "Zone",
      "th_merchandiser": "Merchandiser",
      "col_stock": "Stock / Existence",
      "th_pop": "POP",
      "th_stockouts": "Stockouts",
      "th_evidence": "Evidence",
      "th_actions": "Actions",
      "registered_refs": "registered items",
      "with_photos": "With Photos",
      "without_photos": "No photos",
      "btn_detail": "Detail",
      "showing_reports": "Showing {{count}} of {{total}} audits",
      "page_x_of_y": "Page {{current}} of {{last}}",
      "modal_audit_title": "Visit Audit",
      "label_pdv": "Point of Sale / Tax ID:",
      "label_merchandiser": "Merchandiser:",
      "label_zone_route": "Zone / Route:",
      "label_visit_datetime": "Visit Date & Time in Store:",
      "standard_route": "Standard Route",
      "section_shelf_display": "1. Shelf Status & Display (Before vs. After)",
      "photo_before_badge": "PHOTO BEFORE",
      "photo_after_badge": "PHOTO AFTER (ARRANGED)",
      "photo_before_title": "Before Shelf Photo",
      "photo_after_title": "After Shelf Photo",
      "pop_observations_label": "POP / Display Remarks:",
      "section_inventory_pvp": "2. Current In-Store Inventory & Retail Price (RRP/PVP)",
      "inventory_pvp_hint": "Physical store count and registered consumer retail price",
      "col_sku": "SKU",
      "col_product": "Product / Presentation",
      "col_retail_pvp": "Retail Price ($ USD)",
      "no_initial_inventory": "No inventory count reported for this visit.",
      "section_competitor_prices": "3. Competitor Prices (Benchmarking)",
      "col_rival_brand": "Rival Brand",
      "col_competitor_price": "Price ($ USD)",
      "no_competitor_prices": "No competitor prices reported for this visit.",
      "section_support_notes": "4. In-Store Support Tasks / Notes (Optional)",
      "col_task_detail": "Task / Detail",
      "col_quantity": "Quantity",
      "no_support_notes": "No additional in-store task notes.",
      "section_out_of_stock_title": "5. Detected Stockouts",
      "out_of_stock_hint": "Products with zero shelf availability during audit",
      "shelf_out_of_stock": "Depleted on shelf",
      "badge_no_stock": "Out of Stock",
      "product_category_default": "PRODUCT",
      "product_out_of_stock_default": "Depleted Product",
      "view_analytics": "Market Intelligence",
      "analytics_satisfaction": "Satisfactory Margin",
      "margin_positive_hint": "POS with High or In Range margin",
      "analytics_hotspots": "Hotspots Presence",
      "hotspots_covered_hint": "POS occupying golden display zones",
      "analytics_benchmark": "Competitor Prices",
      "competitor_records_hint": "Monitored rival records",
      "chart_top_stockouts": "Top Shelf Stockouts",
      "chart_top_stockouts_hint": "Products with highest stockout incidence in audited stores",
      "chart_margin_title": "Perceived Margin Distribution",
      "chart_margin_hint": "Commercial evaluation of profitability perceived by the merchant",
      "chart_hotspots_title": "Strategic Hotspots Penetration",
      "chart_hotspots_hint": "Store coverage by high-traffic display zone",
      "chart_pop_title": "POP Material & Display Condition",
      "chart_pop_hint": "Structural status of corporate displays and promotional elements",
      "competitor_benchmark_title": "Competitor Price Benchmarking",
      "competitor_benchmark_hint": "Comparative pricing analysis against rival brands in the field",
      "col_margin": "Perceived Margin",
      "col_hotspots": "Hotspots",
      "label_margin": "Perceived Margin:",
      "label_hotspots": "Display Location:",
      "margin_high": "High",
      "margin_in_range": "In Range",
      "margin_low": "Low",
      "margin_none": "Not Reported",
      "hotspot_cabecera_gondola": "Gondola Endcap",
      "hotspot_linea_caja": "Checkout Area",
      "hotspot_nivel_ojos": "Eye Level (Golden Zone)",
      "hotspot_isla_promocional": "Promotional Island",
      "no_hotspots": "No hotspots occupied",
      "section_margin_hotspots": "2. Margin Perception & Strategic Location",
      "section_pop_materials": "3. POP Material Evaluation",
      "search_competitor_placeholder": "Filter by brand, product, customer or zone...",
      "affected_pdvs": "affected stores",
      "stockouts_reported": "stockouts",
      "benchmark_brand": "Brand",
      "benchmark_product": "Product / Presentation",
      "benchmark_price": "Price ($ USD)",
      "benchmark_store": "Store / Customer",
      "benchmark_zone": "Zone",
      "benchmark_date": "Date",
      "no_competitors_found": "No competitor price records match the filters.",
      "triage_damaged_displays": "Damaged Displays",
      "triage_low_margin": "Low Margin POS",
      "triage_critical_stockouts": "Critical Stockouts",
      "triage_badge_action": "Action Required",
      "triage_badge_good": "Optimal",
      "drilldown_title": "Drill-Down: Audited Stores",
      "drilldown_subtitle": "Traceability of records reported by merchandisers in the field",
      "drilldown_view_audit": "View Full Audit",
      "drilldown_damaged_title": "Stores with Damaged Displays",
      "drilldown_no_display_title": "Stores Without Corporate Displays",
      "drilldown_good_display_title": "Stores with Display in Good Condition",
      "drilldown_low_margin_title": "Stores with Low Perceived Margin",
      "drilldown_in_range_margin_title": "Stores with In-Range Margin",
      "drilldown_high_margin_title": "Stores with High Perceived Margin",
      "drilldown_stockout_for": "Stores with Stockout in: ",
      "drilldown_hotspot_for": "Stores with Hotspot in: ",
      "drilldown_no_records": "No specific records found for this category.",
      "drilldown_photo_evidence": "Photo Evidence",
      "drilldown_damage_note": "Damage Observation",
      "axis_trade_marketing": "1. Trade Marketing & Shelf Visibility",
      "axis_trade_marketing_subtitle": "Condition of POP materials and physical placement in golden high-traffic zones",
      "axis_pricing_margin": "2. Pricing Competitiveness & Perceived Profitability",
      "axis_pricing_margin_subtitle": "Merchant profitability opinion combined with rival brand market prices",
      "axis_stockouts": "3. Shelf Availability & Stockout Impact",
      "axis_stockouts_subtitle": "Products with physical inventory absence in store aisles",
      "view_affected_stores": "View Stores",
      "agenda_monitor_title": "Route Schedule & Live Monitor",
      "agenda_monitor_subtitle": "Weekly supervision of visits, scheduled clients and real-time execution status.",
      "btn_refresh_live": "Refresh Live",
      "kpi_scheduled_visits": "Scheduled Visits",
      "kpi_completed_visits": "Completed Visits",
      "kpi_in_progress_visits": "On Site (In Progress)",
      "kpi_effectiveness": "Route Effectiveness",
      "visit_detail_title": "Scheduled Visit Details",
      "btn_save_schedule": "Save Schedule",
      "select_zone_to_plan": "Select a Zone to Plan",
      "choose_zone": "-- Choose a Zone --",
      "loading_customers_routes": "Loading customers and routes...",
      "customers_drag": "Customers (Drag & Drop)",
      "customers_drag_description": "Drag customers to weekdays. You can schedule a customer on multiple days.",
      "day_monday": "Monday",
      "day_tuesday": "Tuesday",
      "day_wednesday": "Wednesday",
      "day_thursday": "Thursday",
      "day_friday": "Friday",
      "day_saturday": "Saturday",
      "day_sunday": "Sunday",
      "customer_already_scheduled_warning": "This customer is already scheduled for this day.",
      "schedule_saved_success": "Schedule saved successfully",
      "schedule_save_error": "Error saving schedule",
      "dispatch_title": "Dispatch & Fleet Management",
      "dispatch_sheets_title": "Load Sheets & Dispatches",
      "btn_new_dispatch": "New Dispatch Route",
      "btn_refresh": "Refresh",
      "all_caught_up": "All caught up",
      "no_paid_orders_dispatch": "No paid orders pending dispatch in any zone.",
      "orders_count_badge": "Orders",
      "total_amount_dispatch": "Total Amount to Dispatch:",
      "btn_print_route_sheet": "Print Route Sheet",
      "btn_confirm_dispatch": "Confirm Dispatch",
      "generating_label": "Generating...",
      "modal_confirm_dispatch_title": "Confirm Dispatch",
      "confirm_dispatch_question": "Are you sure you want to mark all orders in this zone as Dispatched:",
      "irreversible_action_warning": "This action is irreversible. Make sure you have printed the route sheet before confirming.",
      "btn_yes_confirm_dispatch": "Yes, Confirm Dispatch",
      "processing_label": "Processing...",
      "search_dispatch_placeholder": "Search dispatch, driver or vehicle...",
      "th_dispatch_number": "Dispatch #",
      "th_driver": "Driver",
      "th_vehicle": "Vehicle / Plate",
      "th_orders_count": "Orders Count",
      "th_dispatch_status": "Status",
      "users_title": "Staff & Internal Governance",
      "btn_new_user": "New Employee / User",
      "search_user_placeholder": "Search by name, email or document...",
      "th_full_name": "Full Name",
      "th_email": "Email",
      "th_document": "Document / ID",
      "th_role": "System Role",
      "modal_new_user": "Register New Employee",
      "modal_edit_user": "Edit Employee & Permissions",
      "field_full_name": "Full Name",
      "field_role": "Administrative Role",
      "loading_catalogs_server": "Loading server catalogs...",
      "section_personal_data": "1. Employee Personal Details",
      "leave_blank_keep_password": "(Leave blank to keep current password)",
      "temp_password_notice": "A temporary access password will be generated automatically and sent by email to the employee upon completion.",
      "section_operational_assignment": "2. Operational Assignment, Zone & Hierarchy",
      "select_role_placeholder": "Select a Role",
      "field_hierarchy_supervisor": "Hierarchy / Supervisor",
      "not_applicable_superadmin": "(Not applicable for SuperAdmin)",
      "not_applicable_reports_to_none": "-- Not applicable (SuperAdmin reports to none) --",
      "select_role_first_placeholder": "-- Select an Access Role first --",
      "btn_create_user": "Create User",
      "credentials_created_title": "Access Credentials Created",
      "email_notification_sent": "Email notification sent",
      "email_notification_sent_desc": "An automated email has been sent to {{email}}.",
      "employee_label": "Employee:",
      "temp_password_label": "Temporary Password:",
      "copied_to_clipboard": "Message Copied to Clipboard!",
      "btn_copy_access_message": "Copy Access Message to Clipboard",
      "master_data_title": "Master Data Management & Business Parameters",
      "master_data_subtitle": "Centralized configuration of product categories, commercial families, receiving payment accounts and field visit parameters.",
      "tab_categories": "Product Categories",
      "tab_families_brands": "Product Families (Brands)",
      "tab_payment_methods": "Payment Accounts & Methods",
      "tab_no_sale_reasons": "No Sale Reasons (Visits)",
      "tab_global_settings": "Global Settings",
      "tab_brands": "Product Families (Brands)",
      "tab_families": "Product Families (Brands)",
      "tab_price_lists": "Price Lists",
      "categories_table_title": "Product Catalog Categories",
      "categories_table_subtitle": "Departments that structure the mobile catalog and automatic SKU prefix generation.",
      "th_sku_prefix": "SKU Prefix",
      "th_category_icon": "Category Icon",
      "th_category_name": "Category Name",
      "th_catalog_status": "Catalog Visibility",
      "no_categories_registered": "No categories registered.",
      "btn_new_category": "New Category",
      "families_brands_title": "Product Families (Commercial Brands)",
      "families_brands_subtitle": "Management of manufacturing brands and product families (e.g. Mavesa, Polar, Kraft).",
      "btn_new_family": "New Family",
      "th_family_logo": "Logo",
      "th_family_code": "Family Code",
      "th_family_name": "Family Name (Brand)",
      "field_brand_logo": "Brand Logo or Image",
      "btn_change_logo": "Change Logo",
      "btn_upload_logo": "Upload Logo / Image",
      "btn_remove_logo": "Remove Logo",
      "brand_logo_hint": "Formats: PNG, JPG, WebP or SVG. Stored directly in S3 / DigitalOcean Spaces bucket.",
      "toast_image_uploaded": "Logo uploaded to bucket successfully",
      "toast_error_upload_image": "Error uploading image to bucket",
      "no_families_registered": "No product families registered.",
      "payment_methods_title": "Payment Receiving Accounts & Channels",
      "payment_methods_subtitle": "Configure the bank and collection details displayed to customers during Mobile App checkout.",
      "btn_new_payment_method": "New Account / Method",
      "th_method_type": "Method Type",
      "th_account_title": "Title & Channel",
      "th_bank_details": "Bank / Destination Details",
      "th_holder": "Account Holder",
      "no_payment_methods_configured": "No payment methods configured.",
      "modal_payment_method_title": "Configure Payment Receiving Account",
      "field_payment_type": "Payment Method Type",
      "type_pago_movil": "Pago Móvil (Mobile Payment)",
      "type_transfer": "Bank Transfer (VES)",
      "type_zelle": "Zelle (USD)",
      "type_cash": "Cash / Foreign Currency (USD)",
      "field_method_title": "Display Title (e.g. Pago Móvil)",
      "field_method_subtitle": "Subtitle / Badge (e.g. Instant • Banco de Venezuela)",
      "field_bank_name": "Bank Name & Code (e.g. 0102 Banco de Venezuela)",
      "field_document_id": "Tax ID / Document (e.g. J-012345678-9)",
      "field_phone_number": "Mobile Payment Phone (e.g. 0412-1234567)",
      "field_account_number": "Account Number (20 digits)",
      "field_zelle_email": "Zelle Email Address",
      "field_account_holder": "Account Holder / Company Legal Name",
      "field_payment_instructions": "Instructions for Customer",
      "field_payment_currency": "Currency",
      "placeholder_sku_prefix": "E.g. LAC, EMB, BEB, VIV",
      "placeholder_category_name": "E.g. Dairy & Derivatives, Groceries",
      "placeholder_family_code": "E.g. MAVESA, POLAR, KRAFT",
      "placeholder_family_name": "E.g. Mavesa, Alimentos Polar, Kraft",
      "placeholder_method_title": "E.g. Pago Móvil, Bank Transfer",
      "placeholder_method_subtitle": "E.g. Instant • Banco de Venezuela",
      "placeholder_bank_name": "E.g. 0102 Banco de Venezuela",
      "placeholder_document_id": "E.g. J-012345678-9",
      "placeholder_phone_number": "E.g. 0412-1234567",
      "placeholder_account_number": "E.g. 01020123456789012345",
      "placeholder_zelle_email": "E.g. payments@company.com",
      "placeholder_account_holder": "E.g. Rutex Logistics C.A.",
      "placeholder_instructions": "E.g. Once payment is made, capture the receipt. You must attach the reference number.",
      "placeholder_reason_code": "E.g. CLOSED_STORE, NO_LIQUIDITY",
      "placeholder_reason_description": "E.g. Store closed at the time of the commercial visit",
      "no_sale_reasons_title": "No Sale Reasons (Field Visits)",
      "no_sale_reasons_subtitle": "Mandatory reasons for commercial advisors when closing customer visits without generating an order.",
      "btn_new_no_sale_reason": "New Reason",
      "th_reason_code": "Reason Code",
      "th_reason_description": "Reason Description",
      "no_reasons_registered": "No non-sale reasons registered.",
      "company_general_variables": "Company General Settings",
      "superadmin_only_hint": "(Requires SuperAdmin role)",
      "system_variables": "System Variables",
      "server_timezone": "Server Timezone",
      "base_currency": "Base Currency",
      "timezone_help_text": "Affects timestamps for weighing, visits and audit transactions.",
      "currency_help_text": "Default currency for catalog pricing and order calculation.",
      "btn_save_config": "Save Settings",
      "th_key_identifier": "Key / Identifier",
      "th_visible_name": "Visible Name",
      "status_visible": "Visible",
      "status_hidden": "Hidden",
      "click_to_toggle_status": "Click to toggle status",
      "btn_delete": "Delete",
      "confirm_delete_master_record": "Are you sure you want to delete this record? This action cannot be undone.",
      "btn_add": "Add",
      "btn_save": "Save",
      "toast_error_load_categories": "Error loading product categories",
      "toast_error_load_families": "Error loading product families",
      "toast_error_load_payment_methods": "Error loading payment methods",
      "toast_error_load_no_sale_reasons": "Error loading no sale reasons",
      "toast_error_load_settings": "Error loading global settings",
      "toast_warning_fill_fields": "Please complete all required fields.",
      "toast_success_record_saved": "Record saved successfully",
      "toast_success_record_deleted": "Record deleted successfully",
      "toast_success_status_updated": "Status updated successfully",
      "toast_success_settings_saved": "Global settings updated successfully",
      "profile_title": "My User Profile",
      "edit_profile_info": "Edit Profile Information",
      "not_registered": "Not registered",
      "btn_saving": "Saving...",
      "account_status": "Account Status",
      "secure_logout": "Secure Logout",
      "appearance_preferences": "Appearance Preferences",
      "dark_light_mode": "Dark / Light Mode",
      "dark_light_description": "Toggle visual interface mode in real time",
      "change_secure_password": "Change Secure Password",
      "current_password": "Current Password *",
      "enter_current_password": "Enter your current password",
      "new_password": "New Password *",
      "min_6_chars": "Minimum 6 characters",
      "confirm_new_password": "Confirm New Password *",
      "repeat_new_password": "Repeat new password",
      "btn_update_password": "Update Password",
      "btn_updating": "Updating...",
      "confirm_logout_title": "Confirm Logout",
      "confirm_logout_msg": "Are you sure you want to log out? Your active token will be revoked on the server for security.",
      "btn_yes_logout": "Yes, Log Out",
      "profile_info_updated_success": "Profile information updated successfully.",
      "profile_info_update_error": "Error updating profile information.",
      "password_update_success_redirect": "Your password was updated successfully. Redirecting to login...",
      "gallery_title": "Product Image & Asset Gallery",
      "gallery_subtitle": "Central images stored on Rutex server and synced with App and Backoffice.",
      "btn_upload_image": "Upload New Image",
      "uploading_images": "Uploading images...",
      "search_gallery": "Search images by filename or SKU...",
      "image_available": "image available",
      "images_available": "images available",
      "loading_gallery": "Loading media gallery...",
      "loading_gallery_desc": "Fetching images from central Rutex storage",
      "no_images_found": "No images found in gallery.",
      "no_images_search_match": "No images match the search term.",
      "no_images_in_server": "No images on the central server yet.",
      "btn_upload_now": "Upload images now",
      "image_uploaded_success": "Image uploaded to gallery successfully",
      "confirm_delete_image_server": "Are you sure you want to permanently delete this image from the server?",
      "delete_from_server": "Delete from Server",
      "error_uploading_images": "Error uploading images to server.",
      "error_deleting_image": "Error deleting image.",
      "mandatory_password_update": "Mandatory Password Update",
      "mandatory_password_update_desc": "For security reasons, you must change your temporary password to a definitive one before entering.",
      "current_temp_password": "Current Temporary Password",
      "enter_temp_password_received": "Enter the temporary password received",
      "new_definitive_password": "New Definitive Password",
      "btn_update_password_and_enter": "Update Password & Sign In",
      "btn_cancel_and_logout": "Cancel and Log Out",
      "forgot_password_title": "Password Recovery",
      "forgot_password_subtitle": "Enter your registered email or RIF to receive a 6-digit verification code.",
      "enter_email_or_rif": "Registered email or RIF",
      "btn_send_recovery_code": "Send Recovery Code",
      "enter_6_digit_code": "Verification Code (6 digits)",
      "code_sent_notice": "If the entered email or RIF is registered with RUTEX, you will receive a code to reset your password.",
      "enter_code_sent_notice": "Enter the 6-digit code sent to your registered address to continue.",
      "request_code_again": "Request code again",
      "code_6_digits_error": "Code must be exactly 6 digits.",
      "min_6_chars_error": "Password must be at least 6 characters.",
      "passwords_not_match": "Passwords do not match.",
      "btn_verify_code": "Verify Code",
      "new_password_title": "New Password",
      "new_password_subtitle": "Set your new password of at least 6 characters.",
      "new_password_label": "New Password",
      "confirm_password_label": "Confirm New Password",
      "btn_reset_password": "Reset Password",
      "password_updated_success": "Your password has been updated successfully. Please sign in with your new credentials.",
      "code_expired_error": "The recovery code has expired. Please request a new one.",
      "code_invalid_error": "The entered code is incorrect. Please verify and try again.",
      "access_denied_admin_only": "Access denied. This portal is exclusive to administrative personnel.",
      "invalid_credentials": "Invalid credentials.",
      "server_connection_error": "A connection error occurred with the server.",
      "branding_quote_title": "Rutex is not just about mapping paths, it is about optimizing the exchange of value. Born from efficiency in movement.",
      "branding_quote_subtitle": "The Route does not just move products, it moves solutions. The suffix 'Ex' is extremely powerful because it evokes expansion and experience.",
      "all_rights_reserved": "All rights reserved.",
      "th_rubro_frequency": "CHANNEL / SUBCATEGORY",
      "all_rubros": "All Business Types",
      "rubro_bodega": "Grocery / Corner Store",
      "rubro_supermarket": "Supermarket",
      "rubro_minimarket": "Minimarket",
      "rubro_bakery": "Bakery / Pastry",
      "rubro_restaurant": "Restaurant / Food Service",
      "rubro_pharmacy": "Pharmacy",
      "rubro_wholesaler": "Wholesaler / Distributor",
      "rubro_other": "Other",
      "unsegmented": "Unsegmented",
      "onboarding_commercial_profile": "Commercial Profile & Segmentation (Onboarding)",
      "pending_onboarding": "⏳ Pending Onboarding",
      "segmented_done": "✓ Segmented",
      "rubro_trade_type": "Business Type / Trade:",
      "undefined_text": "Undefined",
      "replenishment_frequency": "Replenishment Frequency:",
      "not_specified": "Not specified",
      "top_interest_categories": "Top Interest Categories:",
      "no_registered_categories": "No registered categories",
      "digital_documents_attached": "Attached Digital Documents",
      "tab_categories_short": "Categories",
      "tab_families_short": "Brands / Families",
      "tab_payments_short": "Accounts & Payments",
      "tab_reasons_short": "No-Sale Reasons",
      "tab_merchandising_tasks_short": "Support Tasks",
      "merchandising_tasks_title": "Store Support Tasks Catalog",
      "merchandising_tasks_subtitle": "Operational activities selectable by merchandisers during store audit visits.",
      "btn_new_merchandising_task": "+ New Task",
      "th_task_code": "Task Code",
      "th_task_name": "Task Description",
      "placeholder_task_code": "Ex: REBANADO_BANDEJEO, ROTACION_FIFO",
      "placeholder_task_name": "Ex: Slicing and Tray Packaging in Deli",
      "no_tasks_registered": "No support tasks registered.",
      "tab_merchandising_task": "Support Task",
      "toast_error_load_merchandising_tasks": "Error loading support tasks",
      "error_save_task": "Error saving support task",
      "support_tasks_executed": "Executed Support Tasks:",
      "operational_notes_label": "Additional Notes / Observations:",
      "tab_settings_short": "Global Config",
      "search_zone_label": "Search Zone",
      "filter_by_vendor": "Filter by Sales Rep",
      "all_vendors": "All Sales Reps",
      "unassigned_zones": "Unassigned Zones",
      "loading_zones": "Loading distribution zones...",
      "loading_zones_sub": "Synchronizing polygons and assigned routes",
      "th_canal_comercial": "Commercial Channel",
      "field_canal_comercial": "Commercial Channel",
      "all_canales": "All Channels",
      "select_channel_placeholder": "Select channel...",
      "canal_transformadores": "Processors (Food Service)",
      "canal_transformadores_badge": "Processors ($500)",
      "canal_supermercados_bodegones": "Supermarkets & Bodegones (Retail)",
      "canal_retail_badge": "Retail ($1,200)",
      "canal_tiendas_bodegas": "Traditional Stores & Groceries",
      "canal_tradicional_badge": "Traditional ($300)",
      "subcat_trade_label": "Commercial Subcategory / Business Type:",
      "field_subcategoria_rubro": "Subcategory / Business Type *",
      "field_subcategoria_required": "Subcategory is required.",
      "field_credit_limit_label": "Purchase / Credit Limit ($)",
      "assigned_credit_limit_label": "Assigned Purchase / Credit Limit:",
      "catalog_view_configured": "Configured Catalog View:",
      "catalog_view_industrial": "Industrial Presentations / Blocks",
      "catalog_view_retail": "Mass Consumption / Retail",
      "catalog_view_traditional": "Mass Consumption / Traditional",
      "no_channel_assigned": "No channel assigned",
      "detected_channel": "Detected Commercial Channel:",
      "suggested_limit": "Suggested: ${{amount}} USD",
      "optgroup_transformadores": "Processors (Food Service)",
      "optgroup_retail": "Retail / Mass Consumption",
      "optgroup_tradicional": "Traditional Channel",
      "subcat_restaurantes": "Restaurants",
      "subcat_panaderias_pastelerias": "Bakeries / Pastry Shops",
      "subcat_pizzerias": "Pizzerias",
      "subcat_hoteles": "Hotels",
      "subcat_food_service": "Food Service",
      "subcat_supermercados": "Supermarkets",
      "subcat_hipermercados": "Hypermarkets",
      "subcat_bodegones": "Bodegones (Specialty Stores)",
      "subcat_abastos": "Corner Stores",
      "subcat_tiendas_conveniencia": "Convenience Stores",
      "subcat_bodega": "Corner Grocery / Bodega",
      "credit_terms_channels_title": "Commercial Credit Terms & Channels",
      "credit_terms_channels_subtitle": "Configuration of payment terms (credit days per invoice) and suggested limits per business channel.",
      "credit_days_invoice_label": "Credit Days (Invoice Payment Term)",
      "credit_days_suffix": "days term",
      "credit_days_badge": "days",
      "suggested_credit_limit": "Suggested Limit (USD)",
      "apply_to_existing_clients": "Update credit days for all existing customers across each commercial channel",
      "apply_to_existing_clients_help": "If enabled, saving will update the credit term for all active customers according to their assigned channel.",
      "field_dias_credito": "Credit Days (Invoice Grace Term) *",
      "dias_credito_help": "Term in days the customer has before their invoices become overdue.",
      "toast_success_settings_with_propagation": "Global settings updated and applied to {{count}} existing customers.",
      "th_credito_plazo": "LIMIT / TERM",
      "credit_days_term": "Credit Days / Term:",
      "credit_days_count": "{{days}} days",
      "field_channel_default_credit_limit": "Default Credit Limit ($)",
      "badge_only_new_customers": "New customers only",
      "field_channel_credit_days": "Credit Days per Invoice",
      "credit_days_term_short": "Grace term",
      "channel_default_limit_hint": "Baseline limit assigned automatically upon customer registration or segmentation.",
      "channel_default_days_hint": "Calendar days allowed before each invoice becomes overdue.",
      "channel_desc_transformadores": "Restaurants, bakeries, pizzerias and hotels",
      "channel_desc_retail": "Supermarkets, hypermarkets and specialty stores",
      "channel_desc_tradicional": "Grocery stores, convenience stores and corner shops",
      "channel_badge_b2b": "Food Service / B2B",
      "channel_badge_retail": "Retail / Mass Market",
      "channel_badge_tradicional": "Traditional Channel",
      "channel_name_transformadores": "Processors",
      "channel_name_retail": "Supermarkets & Bodegas",
      "channel_name_tradicional": "Traditional Stores & Shops",
      "propagation_card_title": "Update credit days for all existing customers across channels",
      "propagation_card_subtitle": "Applies new credit days to all existing customer accounts in each channel. The modified credit limit will only be assigned as default to new customers.",
      "credit_terms_channels_title": "Credit Terms & Commercial Channels",
      "credit_terms_channels_subtitle": "Configuration of payment terms (credit days per invoice) and baseline limits by business channel.",
      "credit_days_badge": "days",
      "btn_save_config": "Save Configuration",
      "th_credit_status": "CREDIT",
      "th_total_order": "TOTAL INVOICE ($)",
      "field_total_order": "Invoice Total",
      "credit_paid": "Paid",
      "credit_not_delivered": "Pending Delivery",
      "credit_remaining": "remaining",
      "credit_conditions": "Credit & Collection Terms",
      "credit_overdue": "Overdue Invoice",
      "credit_due_today": "Due Today",
      "days_left": "Days Remaining",
      "field_delivered_at": "Delivery Date",
      "field_credit_days": "Granted Term",
      "field_due_date": "Due Date",
      "days": "days",
      "credit_starts_on_delivery": "Credit days will be activated and automatically calculated upon marking the order as \"Delivered\".",
      "tax_rate_label": "Value Added Tax (VAT %)",
      "tax_rate_help_text": "Enter 16 for 16%, 8 for 8%, or 0 to omit VAT. When set to 0.00%, VAT remains hidden across receipts.",
      "tab_home_banners": "Home Banners",
      "home_banners_title": "Home Carousel Banners",
      "home_banners_subtitle": "Configure promotional banners displayed on the customer mobile app home screen.",
      "btn_new_banner": "New Banner",
      "modal_banner_title": "Home Banner",
      "field_banner_tag": "Top Tag (Badge)",
      "placeholder_banner_tag": "e.g. SPECIAL OFFERS, LOGISTICS, FEATURED",
      "field_banner_title": "Main Title",
      "placeholder_banner_title": "e.g. 24H GUARANTEED DELIVERY",
      "field_banner_subtitle": "Subtitle / Secondary Message",
      "placeholder_banner_subtitle": "e.g. Direct shipments to your store in record time",
      "field_banner_action_label": "Button Text",
      "field_banner_order": "Display Order",
      "field_banner_action_type": "Action on Tap",
      "field_banner_category": "Target Category",
      "action_catalog": "General Catalogue",
      "action_category": "Category",
      "no_banners_found": "No banners found in the system.",
      "create_first_banner_hint": "Click on \"New Banner\" to create your first promotion.",
      "send_invitation_new_email": "Send invitation email with temporary password to the new address",
      "send_invitation_resend": "Generate new temporary password and resend invitation email",
      "send_invitation_new_email_desc": "An email address change was detected. When saving with this box checked, the system will generate a temporary access password and send the invitation email with an activation link.",
      "send_invitation_resend_desc": "Check this box if you want to generate a new temporary password and dispatch the invitation email to this employee.",
      "user_updated_invitation_sent": "User updated and invitation email sent successfully."
    }
  },
  es: {
    translation: {
      "hello": "¡Hola! Comencemos",
      "sign_in_continue": "Inicia sesión para continuar.",
      "email": "Correo Electrónico",
      "password": "Contraseña",
      "keep_me_signed_in": "Mantener sesión iniciada",
      "forgot_password": "¿Olvidó su contraseña?",
      "sign_in": "INICIAR SESIÓN",
      "login_btn": "INGRESAR",
      "dont_have_account": "¿No tienes una cuenta?",
      "create_account": "Regístrate",
      "logout": "Cerrar Sesión",
      "welcome_back": "¡Bienvenido de nuevo!",
      "happy_see_you": "¡Nos alegra verte de nuevo!",
      "profile": "Perfil",
      "activity_log": "Registro de Actividad",
      "language": "Idioma",
      "new_here": "¿Eres nuevo aquí?",
      "join_us_today": "¡Únete hoy! Solo toma unos pocos pasos",
      "username": "Nombre de Usuario",
      "country": "País",
      "sign_up": "REGISTRARSE",
      "already_have_account": "¿Ya tienes una cuenta?",
      "agree_terms": "Acepto todos los Términos y Condiciones",
      "agree_terms_required": "Debes aceptar los Términos y Condiciones para registrarte.",
      "register_success_redirect": "¡Registro exitoso! Redirigiendo al inicio de sesión...",
      "search_placeholder": "Buscar pedidos, clientes o productos...",
      "notifications": "Notificaciones",
      "see_all_notifications": "Ver todas las notificaciones",
      "mark_all_read": "Marcar todas como leídas",
      "no_notifications": "No hay nuevas notificaciones",
      "loading": "Cargando...",
      "btn_confirm": "Confirmar",
      "btn_close": "Cerrar",
      "btn_actions": "Acciones",
      "success": "Éxito",
      "error": "Error",
      "warning": "Advertencia",
      "info": "Información",
      "menu_dashboard": "Dashboard",
      "menu_sales_catalog": "Ventas y Catálogo",
      "menu_seller_analytics": "Rendimiento de Vendedores",
      "seller_analytics_title": "Rendimiento y Analítica de Vendedores",
      "seller_analytics_subtitle": "Tablero gerencial de ventas, efectividad de cobranzas, comisiones por pronto pago y metas de facturación.",
      "seller_analytics_config_tiers": "Configurar Comisiones",
      "seller_analytics_assign_targets": "Asignar Metas",
      "seller_analytics_refresh_data": "Actualizar datos",
      "seller_analytics_filter_period": "Período:",
      "seller_analytics_period_current_month": "Mes Actual",
      "seller_analytics_period_last_month": "Mes Anterior",
      "seller_analytics_period_current_week": "Esta Semana",
      "seller_analytics_period_last_week": "Semana Anterior",
      "seller_analytics_period_custom": "Personalizado",
      "seller_analytics_filter_from": "Desde",
      "seller_analytics_filter_to": "Hasta",
      "seller_analytics_filter_seller": "Vendedor:",
      "seller_analytics_all_sellers": "Todos los vendedores",
      "seller_analytics_filter_zone": "Zona:",
      "seller_analytics_all_zones": "Todas las zonas",
      "seller_analytics_clear_filters": "Limpiar Filtros",
      "seller_analytics_kpi_sales": "Total Ventas Facturadas",
      "seller_analytics_kpi_orders_billed": "pedidos facturados",
      "seller_analytics_kpi_avg_ticket": "Ticket Promedio",
      "seller_analytics_kpi_per_order": "por pedido cerrado",
      "seller_analytics_kpi_effective_collection": "Cobranza Efectiva",
      "seller_analytics_kpi_paid_of": "pagadas de",
      "seller_analytics_kpi_total": "totales",
      "seller_analytics_kpi_collection_rate": "Tasa de Cobro",
      "seller_analytics_kpi_of_total_sold": "del monto total vendido",
      "seller_analytics_kpi_pending_collection": "Por Cobrar / Pendiente",
      "seller_analytics_kpi_overdue": "Vencido:",
      "seller_analytics_kpi_invoices_pending": "facturas por cobrar",
      "seller_analytics_kpi_commissions": "Comisiones Ganadas",
      "seller_analytics_kpi_commissions_sub": "por velocidad de cobro",
      "seller_analytics_chart_comparison": "Comparativa de Facturación y Cobranza por Vendedor",
      "seller_analytics_total_sold_label": "Total Vendido ($)",
      "seller_analytics_total_collected_label": "Total Cobrado ($)",
      "seller_analytics_tiers_distribution": "Distribución por Tramo de Cobranza",
      "seller_analytics_commission_label": "Comisión:",
      "seller_analytics_ranking_title": "Ranking y Desempeño Comercial de Vendedores",
      "seller_analytics_ranking_subtitle": "Comparativa detallada de facturación, efectividad de cobranza, comisiones ganadas y cumplimiento de metas",
      "seller_analytics_search_placeholder": "Buscar vendedor o zona...",
      "seller_analytics_th_seller": "Vendedor",
      "seller_analytics_th_sold": "Total Vendido ($)",
      "seller_analytics_th_collected": "Cobrado ($)",
      "seller_analytics_th_pending": "Por Cobrar ($)",
      "seller_analytics_th_target_progress": "Cumplimiento Meta",
      "seller_analytics_th_commission": "Comisión Ganada ($)",
      "seller_analytics_th_actions": "Acciones",
      "seller_analytics_no_zone": "Sin zona",
      "seller_analytics_orders_count": "pedidos",
      "seller_analytics_collected_count": "cobradas",
      "seller_analytics_meta_label": "Meta:",
      "seller_analytics_no_target_badge": "Sin meta fijada",
      "seller_analytics_bonus_payments": "pagos bonificados",
      "seller_analytics_view_breakdown": "Ver desglose de comisiones y tramos",
      "seller_analytics_assign_target": "Asignar o editar meta comercial",
      "seller_analytics_no_sellers_found": "No se encontraron vendedores para los filtros seleccionados",
      "seller_analytics_modal_tiers_title": "Configuración de Tramos de Comisión por Cobranza",
      "seller_analytics_modal_tiers_desc": "Los porcentajes son completamente autogestionables. El incentivo premia la velocidad de cobranza según los días transcurridos desde la entrega del pedido hasta la fecha de pago de la factura.",
      "seller_analytics_modal_th_tier_name": "Nombre del Tramo",
      "seller_analytics_modal_th_days_from": "Días Desde",
      "seller_analytics_modal_th_days_to": "Días Hasta",
      "seller_analytics_modal_th_commission_pct": "Comisión (%)",
      "seller_analytics_modal_th_status": "Estado",
      "seller_analytics_modal_no_limit": "Sin límite",
      "seller_analytics_modal_auto_logic_title": "Lógica de Aplicación Automática",
      "seller_analytics_modal_auto_logic_desc": "Cuando un pago es validado en el sistema, la API calcula la diferencia de días entre la fecha de entrega y la fecha de registro del abono, emparejando automáticamente el tramo correspondiente y devengando el porcentaje definido aquí.",
      "seller_analytics_save_config": "Guardar Configuración",
      "seller_analytics_modal_target_title": "Asignar Meta Comercial",
      "seller_analytics_modal_field_seller": "Vendedor",
      "seller_analytics_modal_select_seller": "Seleccione un vendedor...",
      "seller_analytics_modal_field_period_type": "Tipo de Período",
      "seller_analytics_period_monthly": "Mensual",
      "seller_analytics_period_weekly": "Semanal",
      "seller_analytics_field_start_date": "Fecha Inicio",
      "seller_analytics_field_end_date": "Fecha Fin",
      "seller_analytics_field_target_amount": "Meta en Dinero ($ USD)",
      "seller_analytics_target_help": "Esta meta se visualizará en tiempo real en la app móvil del vendedor.",
      "seller_analytics_btn_save_target": "Asignar Meta",
      "seller_analytics_saving_target": "Guardando meta...",
      "seller_analytics_modal_breakdown_title": "Desglose Comercial:",
      "seller_analytics_modal_total_sales": "Total Ventas",
      "seller_analytics_modal_total_collected": "Total Cobrado",
      "seller_analytics_modal_pending": "Por Cobrar",
      "seller_analytics_modal_commissions_won": "Comisiones Ganadas",
      "seller_analytics_modal_breakdown_subtitle": "Desglose de Comisiones por Tramo de Días",
      "seller_analytics_modal_th_tier_col": "Tramo de Cobranza",
      "seller_analytics_modal_th_pct_col": "Porcentaje (%)",
      "seller_analytics_modal_th_payments_col": "Pagos Registrados",
      "seller_analytics_modal_th_collected_amount": "Monto Cobrado ($)",
      "seller_analytics_modal_th_earned_commission": "Comisión Devengada ($)",
      "seller_analytics_invoices_count": "facturas",
      "seller_analytics_error_load": "No se pudo cargar la información del tablero comercial",
      "seller_analytics_tiers_saved_success": "Tramos y porcentajes de comisión actualizados con éxito",
      "seller_analytics_tiers_saved_error": "Error al guardar los porcentajes de comisión",
      "seller_analytics_select_seller_warning": "Seleccione un vendedor",
      "seller_analytics_valid_amount_warning": "Ingrese una meta en dólares válida",
      "seller_analytics_target_saved_success": "Meta comercial asignada correctamente",
      "seller_analytics_target_saved_error": "Error al asignar la meta comercial",
      "seller_analytics_chart_comparison_sub": "Comparativa de volumen colocado frente a dinero efectivamente cobrado",
      "seller_analytics_chart_no_data": "No hay datos suficientes de ventas para graficar en este período",
      "seller_analytics_tiers_sub": "Incentivo escalonado por velocidad de retorno",
      "seller_analytics_tiers_empty": "Sin cobros registrados en los tramos",
      "seller_analytics_loading": "Consolidando métricas comerciales...",
      "seller_analytics_active_sellers": "vendedores",
      "seller_analytics_kpi_dso_avg": "DSO promedio:",
      "seller_analytics_kpi_up_to_date": "Al día",
      "seller_analytics_period_today": "Hoy",
      "menu_media_gallery": "Galería Multimedia",
      "menu_clients_logistics": "Clientes y Logística",
      "menu_clients": "Clientes",
      "menu_zones_territories": "Zonas y Territorios",
      "menu_route_planner": "Planificador de Rutas",
      "menu_dispatch_manager": "Gestor de Despachos",
      "menu_staff_control": "Personal y Control",
      "menu_my_profile": "Mi Perfil",
      "menu_staff_roles": "Personal y Roles",
      "menu_master_data": "Datos Maestros",
      "menu_faqs": "Preguntas Frecuentes (FAQ)",
      "copyright_text": "Todos los derechos reservados.",
      "system_tagline": "Rutex System • Plataforma Empresarial de Distribución",
      "system_version_title": "Sistema de Gestión Comercial v{{version}} por Alpinca y Lácteos Danny",
      "role_superadmin": "Super Administrador",
      "role_admin": "Administrador",
      "role_seller": "Vendedor / Comercial",
      "role_salesapp": "App de Ventas",
      "role_auditor": "Auditor Comercial",
      "role_warehouse": "Operador de Almacén",
      "role_driver": "Chofer de Despacho",
      "role_customer": "Cliente",
      "role_merchandiser": "Mercaderista",
      "role_supervisor": "Supervisor",
      "orders_console_title": "Consola de Control de Ventas, Pesaje y Logística",
      "tab_for_approval": "0. Por Aprobar (Proforma)",
      "tab_pending": "1. Pendientes por Pesaje",
      "tab_weighing": "2. En Pesaje en Almacén",
      "tab_history": "3. Historial y Cobranza",
      "btn_consolidate": "Consolidar",
      "btn_consolidate_print": "Consolidar e Imprimir",
      "tooltip_select_orders_to_consolidate": "Selecciona uno o más pedidos en la tabla para consolidar",
      "tooltip_consolidate_single": "Consolidar y generar hoja de pesaje para este pedido",
      "tooltip_order_already_selected": "Este pedido ya está incluido en la selección. Usa el botón superior 'Consolidar e Imprimir'",
      "btn_detail": "Detalle",
      "btn_real_kilos": "Kilos Reales",
      "btn_print_sheet": "Hoja de Pesaje",
      "btn_approve_payment": "Aprobar Pago",
      "btn_dispatch": "Despachar",
      "btn_voucher": "Comprobante",
      "btn_mark_delivered": "Marcar Entregado",
      "tooltip_view_voucher": "Ver Comprobante de Pago adjunto",
      "tooltip_proforma_pdf": "Ver / Descargar Factura Proforma PDF",
      "status_in_dispatch": "En Despacho",
      "status_in_weighing": "En Pesaje",
      "status_invoiced": "Facturado",
      "status_delivered": "Entregado",
      "status_completed": "Completado",
      "status_dispatched": "Despachado",
      "status_cancelled": "Cancelado",
      "status_for_payment": "Por Pagar",
      "status_in_verification": "En Verificación",
      "status_approved": "Aprobado",
      "status_rejected": "Rechazado",
      "status_expired": "Vencido",
      "status_annulled": "Anulada",
      "status_not_enabled": "No Habilitado",
      "modal_order_detail": "Detalle del Pedido",
      "modal_weighing_title": "Cargar Pesos Reales de Balanza",
      "timeline_title": "Historial y Trazabilidad de Estados",
      "btn_approve_proforma": "Aprobar y Generar Proforma",
      "btn_reject_order": "Rechazar / Reajustar Pedido",
      "btn_view_proforma_pdf": "Ver Proforma PDF",
      "modal_proforma_title": "Revisión y Generación de Factura Proforma Virtual",
      "modal_reject_title": "Rechazo de Pedido y Liberación de Stock",
      "bcv_rate_badge": "Tasa Oficial BCV del Día:",
      "bcv_rate_loading": "Cargando tasa...",
      "bcv_rate_unavailable": "Tasa no disponible",
      "total_ves_label": "Monto Total en Bolívares (VES):",
      "field_rejection_reason": "Motivo del Rechazo *",
      "stock_release_warning": "Atención: Al rechazar este pedido, el inventario físico reservado será devuelto automáticamente al stock general.",
      "general_search": "Búsqueda General",
      "search_order_placeholder": "Buscar por Nro Pedido, RIF o Cliente...",
      "filter_by_zone": "Filtro por Zona",
      "all_zones": "Todas las Zonas",
      "date_range": "Rango de Fecha",
      "tab_proforma_header": "Pedidos Pendientes de Aprobación Comercial (Proforma)",
      "tab_pending_header": "Pedidos Aprobados Pendientes de Pesaje",
      "tab_weighing_header": "Pedidos en Proceso de Pesaje y Báscula",
      "tab_history_header": "Historial de Pedidos, Facturación y Cobranzas",
      "th_zone": "Zona",
      "th_estimated_total": "Total Estimado",
      "th_real_total": "Total Real",
      "th_order_status": "Estatus Pedido",
      "th_invoice_status": "Estatus Factura",
      "no_zone": "Sin Zona",
      "no_orders_pending_weighing": "No hay pedidos aprobados pendientes de pesaje en la bandeja de entrada.",
      "no_orders_in_history": "No hay órdenes en el historial con estos criterios.",
      "btn_confirm_reject": "Confirmar Rechazo y Liberar Stock",
      "btn_confirm_weighing": "Confirmar Pesaje y Recalcular Total Definitivo",
      "customer_info": "Información del Cliente",
      "order_status": "Estado del Pedido",
      "products_in_order": "Productos en el Pedido",
      "field_payment_terms": "Condición de Pago",
      "failed_load_order_info": "No se pudo cargar la información del pedido.",
      "editable_products_table": "Tabla de Productos Editable (Ajuste Real de Cantidades y Precios)",
      "subtotal_base_usd": "Subtotal Base USD:",
      "iva_usd": "IVA (16%) USD:",
      "total_referential_usd": "TOTAL REFERENCIAL USD ($):",
      "th_requested_qty": "Cant. Solicitada",
      "th_weighed_qty": "Cant. Pesada",
      "th_real_qty_scale": "Kilos / Cantidad Real (Balanza)",
      "th_unit_price": "Precio Unit. ($)",
      "th_subtotal": "Subtotal ($)",
      "th_unit": "Unidad",
      "customers_title": "Gestión de Clientes",
      "btn_import_excel": "Importar Excel",
      "btn_preload_manual": "Pre-cargar Manual",
      "search_customer_placeholder": "Buscar por RIF, Razón Social o Email...",
      "status_all": "Todos los Estados",
      "status_inactive": "Inactivo",
      "status_pending_approval": "Pendiente por Auditar",
      "status_requires_visit": "Requiere Visita de Campo",
      "status_active": "Activo",
      "status_disabled": "Deshabilitado / Bloqueado",
      "status_rejected": "Rechazado / No Aprobado",
      "th_rif": "RIF / Cédula",
      "th_razon_social": "Razón Social",
      "th_category": "Categoría",
      "th_credit_limit": "Límite Crédito ($)",
      "th_status": "Estado",
      "th_actions": "Acciones",
      "btn_approve": "Aprobar",
      "btn_block": "Bloquear",
      "btn_unblock": "Desbloquear",
      "no_customers_found": "No se encontraron clientes.",
      "modal_edit_customer": "Editar Cliente",
      "modal_new_customers": "Cargar Nuevos Clientes",
      "tab_manual_creation": "Creación Manual",
      "tab_bulk_import": "Importación Masiva",
      "manual_alert_notice": "Este cliente se registrará en estado Invitado / Sin Clave (inactive). Cuando ingrese su RIF en la App Móvil, activará su cuenta rápidamente creando su contraseña sin requerir aprobación adicional.",
      "import_alert_notice": "Sube un archivo Excel (.xlsx o .csv) exportado desde tu ERP. Todos los clientes serán cargados en estado Invitado / Sin Clave (inactive). Cuando ingresen su RIF en la App Móvil, activarán su cuenta de forma directa.",
      "field_rif": "RIF o Cédula",
      "field_razon_social": "Razón Social",
      "field_phone": "Teléfono",
      "field_billing_email": "Email de Facturación",
      "field_address": "Dirección Física",
      "field_category": "Categoría",
      "field_credit_limit": "Límite de Crédito ($)",
      "field_assigned_seller": "Vendedor Asignado",
      "select_option": "Seleccione...",
      "no_seller": "Sin Vendedor",
      "field_documents": "Documentos / Imágenes Adjuntas (RIF, Cédula, Registro - Opcional)",
      "documents_help": "Formatos soportados: PDF, JPG, PNG (máx. 10MB). Puedes seleccionar múltiples archivos o agregarlos uno a uno.",
      "add_more_documents": "Adjuntar Nuevos Documentos (Opcional)",
      "select_documents": "Seleccionar Documentos",
      "add_more_documents_btn": "Agregar Más Documentos",
      "clear_all_files": "Desmarcar Todos",
      "selected_files_count": "Archivos Seleccionados",
      "drop_file_label": "Selecciona tu archivo de base de datos",
      "browse_files": "Examinar Archivos",
      "expected_format": "Formato esperado: El archivo debe contener al menos las columnas rif, razon_social, direccion y vendedor_asignado (nombre o correo del vendedor).",
      "modal_approve_title": "Aprobar Cliente",
      "approve_description": "Estás a punto de aprobar este registro. Su cuenta de usuario será activada para ingresar a la App Móvil.",
      "assign_credit_limit": "Asignar Límite de Crédito ($)",
      "credit_limit_help": "Puede ingresar 0 si no se le otorgará crédito inicial.",
      "btn_confirm_approval": "Confirmar Aprobación",
      "btn_cancel": "Cancelar",
      "btn_save_changes": "Guardar Cambios",
      "btn_save_customer": "Guardar Cliente",
      "btn_start_import": "Iniciar Importación",
      "btn_create_customer": "Crear Clientes",
      "total_customers_kpi": "Total Clientes",
      "th_assigned_vendor": "Vendedor Asignado",
      "btn_inspect": "Inspeccionar",
      "btn_visit_inspection": "Visita / Inspección",
      "btn_addresses_gps": "Direcciones & GPS",
      "btn_edit": "Editar",
      "btn_reject_request": "Rechazar Solicitud",
      "btn_request_vendor_visit": "Solicitar Visita del Vendedor",
      "btn_approve_commercial_account": "Aprobar Cuenta Comercial",
      "btn_edit_customer_data": "Editar Datos del Cliente",
      "assign_field_visit_title": "Asignar Visita de Campo al Vendedor",
      "visit_status_notice": "Al guardar, el estatus pasará a Requiere Visita de Campo y se generará automáticamente la Tarea para el vendedor asignado.",
      "field_assigned_seller_required": "Vendedor Asignado *",
      "select_vendor_placeholder": "-- Seleccionar Vendedor --",
      "select_zone_placeholder": "-- Seleccionar Zona --",
      "field_instructions_vendor": "Notas o Instrucciones para el Vendedor",
      "btn_create_visit_task": "Generar Tarea de Visita",
      "field_initial_credit_limit": "Límite de Crédito Inicial ($) *",
      "field_rejection_reason": "Motivo del Rechazo *",
      "btn_confirm_rejection": "Confirmar Rechazo",
      "out_of_zone_title": "Ubicación fuera de las Zonas Comerciales Activas",
      "out_of_zone_msg": "Las coordenadas GPS registradas por el cliente no entran en ninguna geocerca activa, por lo que aún no tiene vendedor territorial asignado. Si desea asignarle visita de campo, primero amplíe el polígono de la zona correspondiente en Gestión de Zonas.",
      "field_visit_in_progress": "Visita Comercial de Campo en Proceso",
      "seller_notified": "Vendedor Titular Notificado:",
      "territorial_zone": "Zona Territorial:",
      "instructions_sent": "Instrucciones enviadas:",
      "field_verification_report_title": "Reporte de Visita Comercial de Campo",
      "badge_validated_by_seller": "VALIDADO POR VENDEDOR",
      "badge_observed_rejection": "OBSERVADO / MOTIVOS DE RECHAZO",
      "inspected_by": "Inspeccionado por:",
      "physical_confirmation_note": "Confirmación física: El vendedor verificó en sitio que el establecimiento existe, está operativo y cumple condiciones comerciales.",
      "rejection_reasons_in_field": "Motivos de rechazo marcados en campo:",
      "no_specific_reasons": "No se detallaron motivos específicos.",
      "seller_observations": "Observaciones del Vendedor:",
      "view_gps_capture_point": "Ver punto GPS de captura",
      "facade_photo_title": "Evidencia Fotográfica de Fachada",
      "expand_photo": "Ampliar Fotografía",
      "zoom_facade_title": "Fachada del Comercio",
      "rows_per_page": "Filas por página:",
      "of_range": "de",
      "all_items": "Todos",
      "unassigned": "Sin Asignar",
      "inventory_management": "Gestión de Inventario",
      "stock_out_of_stock": "Agotado (0)",
      "stock_hidden_in_app": "Oculto en App",
      "stock_low": "Bajo",
      "units_per_box_badge": "u/caja",
      "no_category": "Sin Categoría",
      "price_a_label": "Precio A (Factura)",
      "price_b_label": "Precio B (Nota)",
      "reserved_stock": "Reservado",
      "real_stock": "Stock Real",
      "btn_deactivate": "Baja",
      "filters_and_search": "Filtros y Búsqueda",
      "th_img": "Img",
      "th_name": "Nombre",
      "max_stock_reached": "Por ahora, solo podemos llevarte {{count}}",
      "search_product_label": "Buscar Producto",
      "search_product_placeholder": "Buscar por Nombre o SKU...",
      "status_active_in_catalog": "Activos (En catálogo)",
      "status_inactive_disabled": "Inactivos (Baja)",
      "all_categories": "Todas las Categorías",
      "products_and_stock": "Productos y Stock",
      "no_products_in_inventory": "No hay productos en el inventario.",
      "modal_create_product": "Crear Nuevo Producto",
      "modal_edit_product": "Editar Producto",
      "step_select_category": "1. Seleccionar Categoría",
      "choose_category_placeholder": "Seleccione Categoría",
      "field_unit_measure": "Unidad de Medida",
      "field_sku": "SKU (Código)",
      "field_product_name": "Nombre del Producto",
      "field_price_usd": "Precio USD ($)",
      "field_units_per_box": "Unidades por Caja / Bulto",
      "field_physical_stock": "Stock Físico",
      "field_min_stock": "Stock Mínimo",
      "field_reserved_stock": "Reservado",
      "field_product_image": "Imagen del Producto",
      "btn_select_gallery": "Seleccionar de Galería",
      "btn_change_gallery": "Cambiar Imagen de Galería",
      "btn_remove_image": "Quitar",
      "field_description": "Descripción",
      "modal_import_products_title": "Importación Masiva de Productos",
      "import_csv_instructions": "El archivo CSV debe tener las siguientes columnas separadas por comas en este exacto orden:",
      "select_inventory_file": "Selecciona tu archivo de inventario",
      "btn_browse_files": "Examinar Archivos",
      "file_selected_label": "{{name}} seleccionado",
      "btn_upload_import": "Subir e Importar",
      "modal_gallery_select_title": "Seleccionar Imagen de la Galería",
      "gallery_select_subtitle": "Haz clic sobre la imagen que deseas asignar a este producto",
      "search_file_placeholder": "Buscar por nombre de archivo...",
      "btn_upload_new_image": "Subir Nueva Imagen",
      "uploading_label": "Subiendo...",
      "loading_media_gallery": "Cargando galería multimedia...",
      "querying_server_images": "Consultando imágenes del servidor central Rutex",
      "no_images_found_gallery": "No se encontraron imágenes en la galería.",
      "no_images_in_gallery_system": "Aún no hay imágenes subidas en la galería del sistema.",
      "assigned_label": "Asignada",
      "dashboard_title": "Consola del Operador",
      "dashboard_subtitle": "Resumen en tiempo real de ventas, pesaje y rutas.",
      "reload_data": "Recargar Datos",
      "pending_weighing": "Por Pescar/Pesar",
      "pending_weighing_desc": "Pedidos en espera de báscula en depósito",
      "pending_payment": "Por Cobrar",
      "pending_payment_desc": "Pedidos pesados pendientes de pago/aprobación",
      "kpi_total_sales": "Ventas Totales",
      "total_sales_desc": "Monto total facturado (excluye cancelados)",
      "ready_dispatched": "Listos / Despachados",
      "ready_dispatched_desc": "Pedidos consolidados listos para la ruta",
      "orders_count_label": "pedidos",
      "weekly_sales_by_day": "Ventas Semanales por Día",
      "weekly_sales_desc": "Montos acumulados de pedidos activos pesados en depósito.",
      "operation_status": "Estatus de la Operación",
      "operation_status_desc": "Distribución porcentual de los pedidos en el flujo de trabajo.",
      "status_pending_weighing_upper": "PENDIENTE DE PESAJE",
      "status_pending_payment_upper": "POR PAGAR / EN ESPERA",
      "status_ready_dispatched_upper": "LISTO PARA DESPACHO / EN RUTA",
      "sales_by_day_dataset": "Ventas por Día ($)",
      "recent_orders": "Historial de Pedidos Recientes",
      "final_consumer": "Consumidor Final",
      "direct_sale": "Venta Directa",
      "no_recent_orders": "No hay pedidos recientes registrados.",
      "pending_tasks": "Tareas Pendientes",
      "log_scale_calibrated": "Báscula de Depósito calibrada exitosamente.",
      "log_route_sheet": "Se generó la Hoja de Carga para la Ruta Norte.",
      "log_inventory_update": "Actualización masiva de inventario completada.",
      "kpi_active_orders": "Pedidos Activos en Flujo",
      "kpi_registered_customers": "Clientes Registrados",
      "kpi_pending_kyc": "Pendientes por Auditar KYC",
      "chart_sales_performance": "Desempeño de Ventas (USD)",
      "chart_top_products": "Productos Más Vendidos",
      "th_order_id": "Pedido #",
      "th_customer": "Cliente",
      "th_amount": "Monto ($)",
      "th_date": "Fecha",
      "quick_actions": "Acciones Rápidas",
      "btn_new_order": "Nuevo Pedido",
      "btn_add_product": "Agregar Producto",
      "btn_register_client": "Registrar Cliente",
      "zones_territories_title": "Zonas y Territorios",
      "btn_new_zone": "Nueva Zona",
      "search_zone_placeholder": "Buscar por nombre de zona o código...",
      "th_zone_code": "Código",
      "th_zone_name": "Nombre de Zona",
      "modal_new_zone": "Nueva Zona de Distribución",
      "modal_edit_zone": "Editar Zona de Distribución",
      "geographic_area_map": "Área Geográfica (Mapa)",
      "undo_point": "Deshacer Punto",
      "clear_map": "Limpiar Mapa",
      "btn_save_zone": "Guardar Zona",
      "route_planner_title": "Planificador de Rutas (Agenda)",
      "menu_agenda_monitor": "Agenda de Rutas",
      "menu_merchandising_reports": "Auditoría de Anaquel",
      "merchandising_reports_title": "Auditoría de Anaquel y Trade Marketing",
      "merchandising_reports_subtitle": "Supervisión de exhibición en góndolas, fotos antes/después, inventario en tienda, precios de competencia y material POP.",
      "view_gallery": "Galería",
      "view_table": "Tabla",
      "kpi_total_audits": "Auditorías",
      "kpi_total_audits_hint": "Reportes recibidos",
      "kpi_audited_pdvs": "PDVs Auditados",
      "kpi_audited_pdvs_hint": "Puntos de venta únicos",
      "kpi_stock_alerts": "Quiebres de Stock",
      "kpi_stock_alerts_hint": "Productos agotados reportados",
      "kpi_pop_good_condition": "Exhibidores OK",
      "kpi_pop_good_condition_hint": "Material POP en buen estado",
      "kpi_photo_coverage": "Cobertura Fotos",
      "kpi_photo_coverage_hint": "Con fotos registradas",
      "filter_from": "Desde",
      "filter_to": "Hasta",
      "filter_merchandiser": "Mercaderista",
      "all_merchandisers": "Todos los Mercaderistas",
      "filter_zone": "Zona",
      "search_pdv_rif": "Buscar PDV / RIF",
      "search_merchandising_placeholder": "Buscar por PDV, RIF, mercaderista o ruta...",
      "clear_filters": "Limpiar filtros",
      "reset_filters": "Restablecer filtros",
      "loading_reports": "Cargando auditorías de anaquel...",
      "no_reports_found": "No se encontraron auditorías",
      "no_reports_found_hint": "No hay reportes de mercaderistas que coincidan con los filtros seleccionados.",
      "pop_no_data": "Sin dato POP",
      "pop_ok": "Exhibidor OK",
      "pop_damaged": "Exhibidor Dañado",
      "pop_none": "Sin Exhibidor",
      "unknown_client": "Punto de Venta",
      "label_initial_inventory": "Stock en tienda:",
      "products": "productos",
      "not_registered": "No registrado",
      "label_out_of_stock": "Quiebres / Agotados:",
      "out_of_stock_tag": "sin stock",
      "zero_out_of_stock": "0 quiebres",
      "view_full_audit": "Ver Auditoría Completa",
      "photo_before": "ANTES",
      "photo_after": "DESPUÉS",
      "no_photo_before": "Sin foto Antes",
      "no_photo_after": "Sin foto Después",
      "btn_zoom": "Ampliar",
      "zoom_view": "Vista Ampliada",
      "th_datetime": "Fecha / Hora",
      "th_pdv": "Punto de Venta (PDV)",
      "th_zone": "Zona",
      "th_merchandiser": "Mercaderista",
      "col_stock": "Existencia / Stock",
      "th_pop": "POP",
      "th_stockouts": "Quiebres",
      "th_evidence": "Evidencia",
      "th_actions": "Acciones",
      "registered_refs": "ref. registradas",
      "with_photos": "Con Fotos",
      "without_photos": "Sin fotos",
      "btn_detail": "Detalle",
      "showing_reports": "Mostrando {{count}} de {{total}} auditorías",
      "page_x_of_y": "Pág. {{current}} de {{last}}",
      "modal_audit_title": "Auditoría de Visita",
      "label_pdv": "Punto de Venta / RIF:",
      "label_merchandiser": "Mercaderista:",
      "label_zone_route": "Zona / Ruta:",
      "label_visit_datetime": "Fecha y Horario en Tienda:",
      "standard_route": "Ruta estándar",
      "section_shelf_display": "1. Estado del Anaquel y Exhibición (Antes vs. Después)",
      "photo_before_badge": "FOTO ANTES",
      "photo_after_badge": "FOTO DESPUÉS (ORDENADO)",
      "photo_before_title": "Foto Antes del Anaquel",
      "photo_after_title": "Foto Después del Anaquel",
      "pop_observations_label": "Observaciones de exhibición / POP:",
      "section_inventory_pvp": "2. Inventario Actual en Tienda y Precio de Venta al Público (PVP)",
      "inventory_pvp_hint": "Conteo de existencia física en tienda y precio de venta al consumidor registrado",
      "col_sku": "SKU",
      "col_product": "Producto / Presentación",
      "col_retail_pvp": "PVP al Consumidor ($ USD)",
      "no_initial_inventory": "No se reportó conteo de inventario en esta visita.",
      "section_competitor_prices": "3. Precios de la Competencia (Benchmarking)",
      "col_rival_brand": "Marca Rival",
      "col_competitor_price": "Precio ($ USD)",
      "no_competitor_prices": "No se reportaron precios de competencia en esta visita.",
      "section_support_notes": "4. Labores de Apoyo en Tienda / Notas (Opcional)",
      "col_task_detail": "Labor / Detalle",
      "col_quantity": "Cantidad",
      "no_support_notes": "Sin notas adicionales de labores en tienda.",
      "section_out_of_stock_title": "5. Quiebres de Stock Detectados",
      "out_of_stock_hint": "Productos sin existencia física en góndola durante la auditoría",
      "shelf_out_of_stock": "Agotado en anaquel",
      "badge_no_stock": "Sin Stock",
      "product_category_default": "PRODUCTO",
      "product_out_of_stock_default": "Producto Agotado",
      "view_analytics": "Inteligencia de Mercado",
      "analytics_satisfaction": "Margen Satisfactorio",
      "margin_positive_hint": "PDVs con margen Alto o En el rango",
      "analytics_hotspots": "Puntos Calientes",
      "hotspots_covered_hint": "PDVs con presencia en zonas estratégicas",
      "analytics_benchmark": "Precios de la Competencia",
      "competitor_records_hint": "Registros de marcas rivales relevados",
      "chart_top_stockouts": "Top Quiebres de Stock en Anaquel",
      "chart_top_stockouts_hint": "Productos con mayor recurrencia de agotamiento en tiendas auditadas",
      "chart_margin_title": "Distribución de Margen Percibido",
      "chart_margin_hint": "Evaluación comercial de rentabilidad percibida por el comercio",
      "chart_hotspots_title": "Penetración en Puntos Calientes",
      "chart_hotspots_hint": "Cobertura en exhibiciones de alto tráfico comercial",
      "chart_pop_title": "Material POP y Exhibición",
      "chart_pop_hint": "Condición física de exhibidores y material promocional",
      "competitor_benchmark_title": "Benchmarking de Precios de Competencia",
      "competitor_benchmark_hint": "Comparativa de precios de marcas rivales recopilada en calle",
      "col_margin": "Margen Percibido",
      "col_hotspots": "Puntos Calientes",
      "label_margin": "Margen Percibido:",
      "label_hotspots": "Ubicación:",
      "margin_high": "Alto",
      "margin_in_range": "En el rango",
      "margin_low": "Bajo",
      "margin_none": "No reportado",
      "hotspot_cabecera_gondola": "Cabecera de Góndola",
      "hotspot_linea_caja": "Línea de Caja",
      "hotspot_nivel_ojos": "Nivel de Ojos (Zona Dorada)",
      "hotspot_isla_promocional": "Isla Promocional",
      "no_hotspots": "Sin puntos calientes",
      "section_margin_hotspots": "2. Percepción de Margen y Ubicación Estratégica",
      "section_pop_materials": "3. Evaluación de Material POP",
      "search_competitor_placeholder": "Filtrar por marca, producto, cliente o zona...",
      "affected_pdvs": "PDVs afectados",
      "stockouts_reported": "quiebres",
      "benchmark_brand": "Marca Rival",
      "benchmark_product": "Producto / Presentación",
      "benchmark_price": "Precio ($ USD)",
      "benchmark_store": "Punto de Venta",
      "benchmark_zone": "Zona",
      "benchmark_date": "Fecha",
      "no_competitors_found": "No se encontraron registros de competencia con los filtros aplicados.",
      "triage_damaged_displays": "Exhibidores Dañados",
      "triage_low_margin": "PDVs con Margen Bajo",
      "triage_critical_stockouts": "Quiebres Críticos",
      "triage_badge_action": "Acción Requerida",
      "triage_badge_good": "Óptimo",
      "drilldown_title": "Detalle Operativo de Comercios",
      "drilldown_subtitle": "Trazabilidad directa al reporte individual relevado por el mercaderista",
      "drilldown_view_audit": "Ver Auditoría Completa",
      "drilldown_damaged_title": "Comercios con Exhibidores Dañados",
      "drilldown_no_display_title": "Comercios Sin Exhibidor Principal",
      "drilldown_good_display_title": "Comercios con Exhibidor en Buen Estado",
      "drilldown_low_margin_title": "Comercios con Margen Percibido Bajo",
      "drilldown_in_range_margin_title": "Comercios con Margen en el Rango",
      "drilldown_high_margin_title": "Comercios con Margen Percibido Alto",
      "drilldown_stockout_for": "Comercios con Quiebre en: ",
      "drilldown_hotspot_for": "Comercios con Presencia en: ",
      "drilldown_no_records": "No se encontraron registros específicos para esta categoría.",
      "drilldown_photo_evidence": "Evidencia Fotográfica",
      "drilldown_damage_note": "Observación del Daño",
      "axis_trade_marketing": "1. Trade Marketing y Visibilidad en Tienda",
      "axis_trade_marketing_subtitle": "Estado de material POP y presencia en zonas estratégicas de alto tráfico",
      "axis_pricing_margin": "2. Competitividad de Precios y Margen Percibido",
      "axis_pricing_margin_subtitle": "Evaluación de rentabilidad del cliente cruzada con precios de la competencia",
      "axis_stockouts": "3. Disponibilidad y Faltantes en Anaquel",
      "axis_stockouts_subtitle": "Productos con ausencia física de inventario en góndolas auditadas",
      "view_affected_stores": "Ver Tiendas",
      "agenda_monitor_title": "Agenda y Monitoreo de Rutas",
      "agenda_monitor_subtitle": "Supervisión semanal de visitas, clientes agendados y estatus de ejecución en tiempo real.",
      "btn_refresh_live": "Actualizar en Vivo",
      "kpi_scheduled_visits": "Visitas Programadas",
      "kpi_completed_visits": "Visitas Completadas",
      "kpi_in_progress_visits": "En Sitio (En Curso)",
      "kpi_effectiveness": "Efectividad de Ruta",
      "visit_detail_title": "Detalle de Visita Agendada",
      "btn_save_schedule": "Guardar Agenda",
      "select_zone_to_plan": "Selecciona una Zona para Planificar",
      "choose_zone": "-- Elige una Zona --",
      "loading_customers_routes": "Cargando clientes y rutas...",
      "customers_drag": "Clientes (Arrastrar)",
      "customers_drag_description": "Arrastra clientes hacia los días. Puedes arrastrar un mismo cliente varias veces.",
      "day_monday": "Lunes",
      "day_tuesday": "Martes",
      "day_wednesday": "Miércoles",
      "day_thursday": "Jueves",
      "day_friday": "Viernes",
      "day_saturday": "Sábado",
      "day_sunday": "Domingo",
      "customer_already_scheduled_warning": "Este cliente ya está agendado para este día.",
      "schedule_saved_success": "Agenda guardada exitosamente",
      "schedule_save_error": "Error al guardar agenda",
      "dispatch_title": "Gestión de Despachos y Flota",
      "dispatch_sheets_title": "Hojas de Carga y Despachos",
      "btn_new_dispatch": "Nueva Ruta de Despacho",
      "btn_refresh": "Actualizar",
      "all_caught_up": "Todo al día",
      "no_paid_orders_dispatch": "No hay pedidos pagados pendientes por despachar en ninguna zona.",
      "orders_count_badge": "Pedidos",
      "total_amount_dispatch": "Monto Total a Despachar:",
      "btn_print_route_sheet": "Imprimir Hoja de Ruta",
      "btn_confirm_dispatch": "Confirmar Despacho",
      "generating_label": "Generando...",
      "modal_confirm_dispatch_title": "Confirmar Despacho",
      "confirm_dispatch_question": "¿Estás seguro de marcar como Despachado todas las órdenes de la zona:",
      "irreversible_action_warning": "Esta acción es irreversible. Asegúrate de haber impreso la hoja de ruta antes de confirmar.",
      "btn_yes_confirm_dispatch": "Sí, Confirmar Despacho",
      "processing_label": "Procesando...",
      "search_dispatch_placeholder": "Buscar despacho, chofer o vehículo...",
      "th_dispatch_number": "Despacho #",
      "th_driver": "Chofer Asignado",
      "th_vehicle": "Vehículo / Placa",
      "th_orders_count": "Cant. Pedidos",
      "th_dispatch_status": "Estado",
      "users_title": "Personal y Gobernanza Interna",
      "btn_new_user": "Nuevo Empleado / Usuario",
      "search_user_placeholder": "Buscar por nombre, correo o documento...",
      "th_full_name": "Nombre Completo",
      "th_email": "Correo Electrónico",
      "th_document": "Documento / Cédula",
      "th_role": "Rol en el Sistema",
      "modal_new_user": "Registrar Nuevo Empleado",
      "modal_edit_user": "Editar Empleado y Permisos",
      "field_full_name": "Nombre Completo",
      "field_role": "Rol Administrativo",
      "loading_catalogs_server": "Cargando catálogos del servidor...",
      "section_personal_data": "1. Datos Personales del Empleado",
      "leave_blank_keep_password": "(Dejar en blanco para mantener la clave actual)",
      "temp_password_notice": "La contraseña temporal de acceso se generará automáticamente y se enviará por correo al empleado al completar el registro.",
      "section_operational_assignment": "2. Asignación Operativa, Zona y Jerarquía",
      "select_role_placeholder": "Seleccione un Rol",
      "field_hierarchy_supervisor": "Jerarquía / Supervisor",
      "not_applicable_superadmin": "(No aplica para SuperAdmin)",
      "not_applicable_reports_to_none": "-- No aplica (SuperAdmin no reporta a nadie) --",
      "select_role_first_placeholder": "-- Seleccione primero un Rol de Acceso --",
      "btn_create_user": "Crear Usuario",
      "credentials_created_title": "Credenciales de Acceso Creadas",
      "email_notification_sent": "Notificación por correo enviada",
      "email_notification_sent_desc": "Se ha enviado un correo electrónico automático a {{email}}.",
      "employee_label": "Empleado:",
      "temp_password_label": "Contraseña Temporal:",
      "copied_to_clipboard": "¡Mensaje Copiado al Portapapeles!",
      "btn_copy_access_message": "Copiar Mensaje de Acceso al Portapapeles",
      "master_data_title": "Módulo de Gestión de Datos Maestros",
      "master_data_subtitle": "Configuración centralizada de categorías, familias comerciales, cuentas receptoras de pagos y parámetros de visitas de campo.",
      "tab_categories": "Categorías de Productos",
      "tab_families_brands": "Familias de Productos (Marcas)",
      "tab_payment_methods": "Cuentas y Métodos de Pago",
      "tab_no_sale_reasons": "Motivos de No Venta (Visitas)",
      "tab_global_settings": "Configuración Global",
      "tab_brands": "Familias de Productos (Marcas)",
      "tab_families": "Familias de Productos (Marcas)",
      "tab_price_lists": "Listas de Precios",
      "categories_table_title": "Categorías del Catálogo de Productos",
      "categories_table_subtitle": "Departamentos que estructuran el catálogo móvil y la generación automática del prefijo SKU.",
      "th_sku_prefix": "Prefijo SKU",
      "th_category_icon": "Ícono de la Categoría",
      "th_category_name": "Nombre de la Categoría",
      "th_catalog_status": "Estado en Catálogo",
      "no_categories_registered": "No se encontraron categorías registradas.",
      "btn_new_category": "+ Nueva Categoría",
      "families_brands_title": "Familias de Productos (Marcas Comerciales)",
      "families_brands_subtitle": "Gestión de marcas fabricantes y familias de productos (ej: Mavesa, Polar, Kraft).",
      "btn_new_family": "+ Nueva Familia",
      "th_family_logo": "Logo",
      "th_family_code": "Código de Familia",
      "th_family_name": "Nombre de la Familia (Marca)",
      "field_brand_logo": "Logo o Imagen de la Marca",
      "btn_change_logo": "Cambiar Logo",
      "btn_upload_logo": "Subir Logo / Imagen",
      "btn_remove_logo": "Quitar Logo",
      "brand_logo_hint": "Formatos: PNG, JPG, WebP o SVG. Se guardará directamente en el bucket S3 / DigitalOcean Spaces.",
      "toast_image_uploaded": "Logo subido con éxito al bucket",
      "toast_error_upload_image": "Error al subir la imagen al bucket",
      "no_families_registered": "No se encontraron familias de productos registradas.",
      "payment_methods_title": "Cuentas y Pasarelas de Recaudación",
      "payment_methods_subtitle": "Configure los datos bancarios y de recaudación que visualizan los clientes en el checkout de la App Móvil.",
      "btn_new_payment_method": "+ Nueva Cuenta / Método",
      "th_method_type": "Tipo de Método",
      "th_account_title": "Título y Canal",
      "th_bank_details": "Datos Bancarios / Destino",
      "th_holder": "Titular de la Cuenta",
      "no_payment_methods_configured": "No hay métodos de pago configurados.",
      "modal_payment_method_title": "Configurar Cuenta / Método de Pago",
      "field_payment_type": "Tipo de Método de Pago",
      "type_pago_movil": "Pago Móvil",
      "type_transfer": "Transferencia Bancaria (VES)",
      "type_zelle": "Zelle (USD)",
      "type_cash": "Efectivo / Divisas (USD)",
      "field_method_title": "Título en Pantalla (ej: Pago Móvil)",
      "field_method_subtitle": "Subtítulo / Etiqueta (ej: Instantáneo • Banco de Venezuela)",
      "field_bank_name": "Banco y Código (ej: 0102 Banco de Venezuela)",
      "field_document_id": "Documento / RIF / Cédula (ej: J-012345678-9)",
      "field_phone_number": "Teléfono de Pago Móvil (ej: 0412-1234567)",
      "field_account_number": "Número de Cuenta (20 dígitos)",
      "field_zelle_email": "Correo Electrónico Zelle",
      "field_account_holder": "Titular / Razón Social de la Cuenta",
      "field_payment_instructions": "Instrucciones de Pago para el Cliente",
      "field_payment_currency": "Moneda",
      "placeholder_sku_prefix": "Ej: LAC, EMB, BEB, VIV",
      "placeholder_category_name": "Ej: Lácteos y Derivados, Víveres",
      "placeholder_family_code": "Ej: MAVESA, POLAR, KRAFT",
      "placeholder_family_name": "Ej: Mavesa, Alimentos Polar, Kraft",
      "placeholder_method_title": "Ej: Pago Móvil, Transferencia Banesco",
      "placeholder_method_subtitle": "Ej: Instantáneo • Banco de Venezuela",
      "placeholder_bank_name": "Ej: 0102 Banco de Venezuela",
      "placeholder_document_id": "Ej: J-012345678-9",
      "placeholder_phone_number": "Ej: 0412-1234567",
      "placeholder_account_number": "Ej: 01020123456789012345",
      "placeholder_zelle_email": "Ej: pagos@empresa.com",
      "placeholder_account_holder": "Ej: Rutex Logistics C.A.",
      "placeholder_instructions": "Ej: Capture el comprobante y registre el número de referencia.",
      "placeholder_reason_code": "Ej: LOCAL_CERRADO, SIN_LIQUIDEZ",
      "placeholder_reason_description": "Ej: Local o establecimiento comercial cerrado",
      "no_sale_reasons_title": "Motivos de No Venta (Visitas en Calle)",
      "no_sale_reasons_subtitle": "Razones obligatorias para que el asesor comercial cierre visitas a clientes sin generar pedido.",
      "btn_new_no_sale_reason": "+ Nuevo Motivo",
      "th_reason_code": "Código del Motivo",
      "th_reason_description": "Descripción del Motivo",
      "no_reasons_registered": "No se encontraron motivos de no venta registrados.",
      "company_general_variables": "Variables Generales de la Empresa",
      "superadmin_only_hint": "(Requiere rol SuperAdmin)",
      "system_variables": "Variables del Sistema",
      "server_timezone": "Zona Horaria del Servidor",
      "base_currency": "Moneda Base del Sistema",
      "timezone_help_text": "Afecta el registro de horas de pesaje, visitas y transacciones de auditoría.",
      "currency_help_text": "Divisa predeterminada para el cálculo de catálogo y pedidos.",
      "btn_save_config": "Guardar Configuración",
      "th_key_identifier": "Clave / Identificador",
      "th_visible_name": "Nombre Visible",
      "status_visible": "Visible",
      "status_hidden": "Oculto",
      "click_to_toggle_status": "Clic para cambiar estado",
      "btn_delete": "Eliminar",
      "confirm_delete_master_record": "¿Está seguro de que desea eliminar este registro? Esta acción no se puede deshacer.",
      "btn_add": "Agregar",
      "btn_save": "Guardar",
      "toast_error_load_categories": "Error al cargar las categorías de productos",
      "toast_error_load_families": "Error al cargar las familias de productos",
      "toast_error_load_payment_methods": "Error al cargar los métodos de pago",
      "toast_error_load_no_sale_reasons": "Error al cargar los motivos de no venta",
      "toast_error_load_settings": "Error al cargar la configuración global",
      "toast_warning_fill_fields": "Por favor complete todos los campos obligatorios.",
      "toast_success_record_saved": "Registro guardado con éxito",
      "toast_success_record_deleted": "Registro eliminado correctamente",
      "toast_success_status_updated": "Estado actualizado correctamente",
      "toast_success_settings_saved": "Configuración global actualizada correctamente",
      "profile_title": "Mi Perfil de Usuario",
      "edit_profile_info": "Editar Información del Perfil",
      "not_registered": "No registrado",
      "btn_saving": "Guardando...",
      "account_status": "Estado de Cuenta",
      "secure_logout": "Cerrar Sesión Segura",
      "appearance_preferences": "Preferencias de Apariencia",
      "dark_light_mode": "Modo Oscuro / Claro",
      "dark_light_description": "Alterna la apariencia visual de toda la interfaz en tiempo real",
      "change_secure_password": "Cambiar Contraseña Segura",
      "current_password": "Contraseña Actual *",
      "enter_current_password": "Ingrese su contraseña actual",
      "new_password": "Nueva Contraseña *",
      "min_6_chars": "Mínimo 6 caracteres",
      "confirm_new_password": "Confirmar Nueva Contraseña *",
      "repeat_new_password": "Repita la nueva contraseña",
      "btn_update_password": "Actualizar Contraseña",
      "btn_updating": "Actualizando...",
      "confirm_logout_title": "Confirmar Cierre de Sesión",
      "confirm_logout_msg": "¿Estás seguro de que deseas cerrar sesión? Tu token de acceso activo será revocado por seguridad en el servidor.",
      "btn_yes_logout": "Sí, Cerrar Sesión",
      "profile_info_updated_success": "Información de perfil actualizada exitosamente.",
      "profile_info_update_error": "Error al actualizar la información del perfil.",
      "password_update_success_redirect": "Tu contraseña se ha actualizado correctamente. Redirigiendo al inicio de sesión...",
      "gallery_title": "Galería de Imágenes de Productos y Recursos",
      "gallery_subtitle": "Imágenes centrales almacenadas en el servidor Rutex y sincronizadas con la App y el Backoffice.",
      "btn_upload_image": "Subir Nueva Imagen",
      "uploading_images": "Subiendo imágenes...",
      "search_gallery": "Buscar imágenes por nombre de archivo o SKU...",
      "image_available": "imagen disponible",
      "images_available": "imágenes disponibles",
      "loading_gallery": "Cargando galería multimedia...",
      "loading_gallery_desc": "Consultando imágenes del almacenamiento central Rutex",
      "no_images_found": "No se encontraron imágenes en la galería.",
      "no_images_search_match": "Ninguna imagen coincide con el término de búsqueda.",
      "no_images_in_server": "Aún no hay imágenes en el servidor central.",
      "btn_upload_now": "Subir imágenes ahora",
      "image_uploaded_success": "Imagen subida a la galería exitosamente",
      "confirm_delete_image_server": "¿Seguro que deseas eliminar permanentemente esta imagen del servidor?",
      "delete_from_server": "Eliminar del Servidor",
      "error_uploading_images": "Error subiendo imágenes al servidor.",
      "error_deleting_image": "Error eliminando la imagen.",
      "mandatory_password_update": "Actualización de Contraseña Obligatoria",
      "mandatory_password_update_desc": "Por motivos de seguridad, debes cambiar tu clave temporal por una nueva contraseña definitiva antes de ingresar.",
      "current_temp_password": "Contraseña Temporal Actual",
      "enter_temp_password_received": "Ingresa la clave temporal recibida",
      "new_definitive_password": "Nueva Contraseña Definitiva",
      "btn_update_password_and_enter": "Actualizar Contraseña e Ingresar",
      "btn_cancel_and_logout": "Cancelar y Cerrar Sesión",
      "forgot_password_title": "Recuperación de Contraseña",
      "forgot_password_subtitle": "Ingresa tu correo electrónico o RIF registrado para recibir un código de verificación de 6 dígitos.",
      "enter_email_or_rif": "Correo electrónico o RIF registrado",
      "btn_send_recovery_code": "Enviar Código de Recuperación",
      "enter_6_digit_code": "Código de Verificación (6 dígitos)",
      "code_sent_notice": "Si el correo o RIF ingresado está registrado en RUTEX, recibirá un código para restablecer su contraseña.",
      "enter_code_sent_notice": "Ingresa el código de 6 dígitos que fue enviado a tu dirección registrada para continuar.",
      "request_code_again": "Volver a solicitar código",
      "code_6_digits_error": "El código debe tener exactamente 6 dígitos.",
      "min_6_chars_error": "La contraseña debe tener al menos 6 caracteres.",
      "passwords_not_match": "Las contraseñas no coinciden.",
      "btn_verify_code": "Verificar Código",
      "new_password_title": "Nueva Contraseña",
      "new_password_subtitle": "Define tu nueva clave de acceso de al menos 6 caracteres.",
      "new_password_label": "Nueva Contraseña",
      "confirm_password_label": "Confirmar Nueva Contraseña",
      "btn_reset_password": "Restablecer Contraseña",
      "password_updated_success": "Su contraseña ha sido actualizada exitosamente. Inicie sesión con sus nuevas credenciales.",
      "code_expired_error": "El código de recuperación ha expirado. Por favor, solicite uno nuevo.",
      "code_invalid_error": "El código ingresado es incorrecto. Verifíquelo e intente de nuevo.",
      "access_denied_admin_only": "Acceso denegado. Este portal es exclusivo para el personal administrativo.",
      "invalid_credentials": "Credenciales inválidas.",
      "server_connection_error": "Ocurrió un error de conexión con el servidor.",
      "branding_quote_title": "Rutex no se trata solo de trazar trayectos en un mapa, sino de optimizar el intercambio de valor. Nace de la eficiencia en el movimiento.",
      "branding_quote_subtitle": "La Ruta no solo mueve productos, mueve soluciones. El sufijo \"Ex\" es sumamente potente porque no tiene un solo significado, sino que evoca expansión y experiencia.",
      "all_rights_reserved": "Todos los derechos reservados.",
      "th_rubro_frequency": "CANAL / SUB-CATEGORÍA",
      "all_rubros": "Todos los Rubros",
      "rubro_bodega": "Bodega / Abasto",
      "rubro_supermarket": "Supermercado",
      "rubro_minimarket": "Minimarket",
      "rubro_bakery": "Panadería / Pastelería",
      "rubro_restaurant": "Restaurante / Comida",
      "rubro_pharmacy": "Farmacia",
      "rubro_wholesaler": "Mayorista / Distribuidor",
      "rubro_other": "Otro",
      "unsegmented": "Sin segmentar",
      "onboarding_commercial_profile": "Perfil Comercial y Segmentación (Onboarding)",
      "pending_onboarding": "⏳ Pendiente de Onboarding",
      "segmented_done": "✓ Segmentado",
      "rubro_trade_type": "Rubro / Tipo de Comercio:",
      "undefined_text": "Sin definir",
      "replenishment_frequency": "Frecuencia de Reposición:",
      "not_specified": "No especificada",
      "top_interest_categories": "Categorías de Mayor Interés:",
      "no_registered_categories": "Sin categorías registradas",
      "digital_documents_attached": "Documentos Digitales Adjuntos",
      "tab_categories_short": "Categorías",
      "tab_families_short": "Marcas / Familias",
      "tab_payments_short": "Cuentas y Pagos",
      "tab_reasons_short": "Motivos de No Venta",
      "tab_merchandising_tasks_short": "Labores de Apoyo",
      "merchandising_tasks_title": "Catálogo de Labores de Apoyo en Tienda",
      "merchandising_tasks_subtitle": "Actividades operativas seleccionables por mercaderistas durante las auditorías en punto de venta.",
      "btn_new_merchandising_task": "+ Nueva Labor",
      "th_task_code": "Código de la Labor",
      "th_task_name": "Descripción de la Labor",
      "placeholder_task_code": "Ej: REBANADO_BANDEJEO, ROTACION_FIFO",
      "placeholder_task_name": "Ej: Rebanado y Bandejeo en Charcutería",
      "no_tasks_registered": "No se encontraron labores de apoyo registradas.",
      "tab_merchandising_task": "Labor de Apoyo",
      "toast_error_load_merchandising_tasks": "Error al cargar las labores de apoyo",
      "error_save_task": "Error al guardar la labor de apoyo",
      "support_tasks_executed": "Labores de Apoyo Realizadas:",
      "operational_notes_label": "Notas / Observaciones Adicionales:",
      "tab_settings_short": "Config. Global",
      "search_zone_label": "Buscar Zona",
      "filter_by_vendor": "Filtrar por Vendedor",
      "all_vendors": "Todos los Vendedores",
      "unassigned_zones": "Zonas sin Asignar",
      "loading_zones": "Cargando zonas de distribución...",
      "loading_zones_sub": "Sincronizando polígonos y rutas asignadas",
      "th_canal_comercial": "Canal Comercial",
      "field_canal_comercial": "Canal Comercial",
      "all_canales": "Todos los Canales",
      "select_channel_placeholder": "Seleccione canal...",
      "canal_transformadores": "Transformadores (Food Service)",
      "canal_transformadores_badge": "Transformadores ($500)",
      "canal_supermercados_bodegones": "Supermercados y Bodegones (Retail)",
      "canal_retail_badge": "Retail ($1.200)",
      "canal_tiendas_bodegas": "Tiendas y Bodegas (Tradicional)",
      "canal_tradicional_badge": "Tradicional ($300)",
      "subcat_trade_label": "Subcategoría Comercial / Rubro:",
      "field_subcategoria_rubro": "Subcategoría / Rubro *",
      "field_subcategoria_required": "La Subcategoría es obligatoria.",
      "field_credit_limit_label": "Límite de Compra / Crédito ($)",
      "assigned_credit_limit_label": "Límite de Compra / Crédito Asignado:",
      "catalog_view_configured": "Vista de Catálogo Configurada:",
      "catalog_view_industrial": "Presentaciones Industriales / Bloques",
      "catalog_view_retail": "Consumo Masivo / Retail",
      "catalog_view_traditional": "Consumo Masivo / Tradicional",
      "no_channel_assigned": "Sin canal asignado",
      "detected_channel": "Canal Comercial Configurado:",
      "suggested_limit": "Sugerido: ${{amount}} USD",
      "optgroup_transformadores": "Transformadores",
      "optgroup_retail": "Retail / Consumo Masivo",
      "optgroup_tradicional": "Canal Tradicional",
      "subcat_restaurantes": "Restaurantes",
      "subcat_panaderias_pastelerias": "Panaderías / Pastelerías",
      "subcat_pizzerias": "Pizzerías",
      "subcat_hoteles": "Hoteles",
      "subcat_food_service": "Food Service",
      "subcat_supermercados": "Supermercados",
      "subcat_hipermercados": "Hipermercados",
      "subcat_bodegones": "Bodegones",
      "subcat_abastos": "Abastos",
      "subcat_tiendas_conveniencia": "Tiendas de conveniencia",
      "subcat_bodega": "Bodega",
      "credit_terms_channels_title": "Condiciones de Crédito y Canales Comerciales",
      "credit_terms_channels_subtitle": "Configuración de plazos de pago (días de crédito por factura) y límites sugeridos por tipo de negocio.",
      "credit_days_invoice_label": "Días de Crédito (Plazo por Factura)",
      "credit_days_suffix": "días de plazo",
      "credit_days_badge": "días",
      "suggested_credit_limit": "Límite Sugerido (USD)",
      "apply_to_existing_clients": "Actualizar días de crédito a todos los clientes existentes en cada canal comercial",
      "apply_to_existing_clients_help": "Si se activa, al guardar se actualizará el plazo de crédito de todos los clientes activos según su canal asignado.",
      "field_dias_credito": "Días de Crédito (Gracia por Factura) *",
      "dias_credito_help": "Plazo en días que tiene el cliente antes de que sus facturas pasen a estatus vencido.",
      "toast_success_settings_with_propagation": "Configuración global actualizada y aplicada a {{count}} clientes existentes.",
      "th_credito_plazo": "LÍMITE / PLAZO",
      "credit_days_term": "Días de Crédito / Plazo:",
      "credit_days_count": "{{days}} días",
      "field_channel_default_credit_limit": "Límite de Crédito Base ($)",
      "badge_only_new_customers": "Solo nuevos clientes",
      "field_channel_credit_days": "Días de Crédito por Factura",
      "credit_days_term_short": "Plazo de gracia",
      "channel_default_limit_hint": "Monto inicial asignado automáticamente al registrarse o segmentarse.",
      "channel_default_days_hint": "Días continuos antes del vencimiento de cada factura.",
      "channel_desc_transformadores": "Restaurantes, panaderías, pizzerías y hoteles",
      "channel_desc_retail": "Supermercados, hipermercados y bodegones",
      "channel_desc_tradicional": "Abastos, tiendas de conveniencia y bodegas",
      "channel_badge_b2b": "Food Service / B2B",
      "channel_badge_retail": "Retail / Masivo",
      "channel_badge_tradicional": "Canal Tradicional",
      "channel_name_transformadores": "Transformadores",
      "channel_name_retail": "Supermercados y Bodegones",
      "channel_name_tradicional": "Tiendas y Bodegas",
      "propagation_card_title": "Actualizar días de crédito a todos los clientes existentes en cada canal",
      "propagation_card_subtitle": "Aplica los nuevos días de crédito a todas las cuentas ya registradas en cada canal. El límite de crédito modificado solo se asignará como valor predeterminado a nuevos clientes.",
      "credit_terms_channels_title": "Condiciones de Crédito y Canales Comerciales",
      "credit_terms_channels_subtitle": "Configuración de plazos de pago (días de crédito por factura) y límites sugeridos por tipo de negocio.",
      "credit_days_badge": "días",
      "btn_save_config": "Guardar Configuración",
      "th_credit_status": "CRÉDITO",
      "th_total_order": "TOTAL FACTURA ($)",
      "field_total_order": "Total Factura",
      "credit_paid": "Pagada",
      "credit_not_delivered": "Sin entregar",
      "credit_remaining": "restante(s)",
      "credit_conditions": "Condiciones de Crédito y Cobranza",
      "credit_overdue": "Factura Vencida",
      "credit_due_today": "Vence Hoy",
      "days_left": "Días Restantes",
      "field_delivered_at": "Fecha de Entrega",
      "field_credit_days": "Plazo Concedido",
      "field_due_date": "Fecha Límite / Vencimiento",
      "days": "días",
      "credit_starts_on_delivery": "Los días de crédito se activarán y calcularán automáticamente al marcar el pedido como \"Entregado\".",
      "tax_rate_label": "Impuesto al Valor Agregado (IVA %)",
      "tax_rate_help_text": "Ingrese 16 para aplicar 16%, u 8 para 8%. Ingrese 0 para omitir el IVA. Si es 0.00%, el IVA permanece oculto.",
      "tab_home_banners": "Banners de Inicio",
      "home_banners_title": "Banners del Carrusel de Inicio",
      "home_banners_subtitle": "Configura los banners promocionales y anuncios que se visualizan en la pantalla principal de la aplicación móvil de los clientes.",
      "btn_new_banner": "Nuevo Banner",
      "modal_banner_title": "Banner de Inicio",
      "field_banner_tag": "Etiqueta Superior (Tag / Badge)",
      "placeholder_banner_tag": "Ej: OFERTAS DE LA SEMANA, LOGÍSTICA, DESTACADO",
      "field_banner_title": "Título Principal",
      "placeholder_banner_title": "Ej: DESPACHO GARANTIZADO 24H",
      "field_banner_subtitle": "Subtítulo / Mensaje Secundario",
      "placeholder_banner_subtitle": "Ej: Envíos directos a tu comercio en tiempo récord",
      "field_banner_action_label": "Texto del Botón",
      "field_banner_order": "Número de Orden",
      "field_banner_action_type": "Acción al Pulsar",
      "field_banner_category": "Categoría Destino",
      "action_catalog": "Catálogo General",
      "action_category": "Categoría",
      "no_banners_found": "No hay banners registrados en el sistema.",
      "create_first_banner_hint": "Haga clic en \"Nuevo Banner\" para crear la primera promoción.",
      "send_invitation_new_email": "Enviar correo de invitación con contraseña temporal al nuevo correo",
      "send_invitation_resend": "Generar nueva contraseña temporal y enviar correo de invitación",
      "send_invitation_new_email_desc": "Se detectó un cambio en el correo electrónico. Al guardar con esta casilla marcada, el sistema generará una contraseña temporal de acceso y enviará la invitación por correo con su enlace de activación.",
      "send_invitation_resend_desc": "Marque esta casilla si desea generar una nueva clave temporal de acceso y despachar la invitación por correo electrónico.",
      "user_updated_invitation_sent": "Usuario actualizado e invitación enviada exitosamente."
    }
  }
};

export const translateRole = (role, t) => {
  if (!role) return t('role_admin', 'Administrador');
  const normalized = String(role).toLowerCase().trim();
  switch (normalized) {
    case 'superadmin':
    case 'super admin':
    case 'super_admin':
      return t('role_superadmin', 'Super Administrador');
    case 'admin':
    case 'administrador':
      return t('role_admin', 'Administrador');
    case 'seller':
    case 'vendedor':
      return t('role_seller', 'Vendedor / Comercial');
    case 'salesapp':
      return t('role_salesapp', 'App de Ventas');
    case 'auditor':
      return t('role_auditor', 'Auditor Comercial');
    case 'warehouse':
    case 'almacen':
      return t('role_warehouse', 'Operador de Almacén');
    case 'driver':
    case 'chofer':
      return t('role_driver', 'Chofer de Despacho');
    case 'customer':
    case 'cliente':
      return t('role_customer', 'Cliente');
    case 'merchandiser':
    case 'mercaderista':
      return t('role_merchandiser', 'Mercaderista');
    case 'supervisor':
      return t('role_supervisor', 'Supervisor');
    default:
      return role;
  }
};

export const translateStatus = (status, t) => {
  if (!status) return status;
  const normalized = String(status).toLowerCase().trim();
  switch (normalized) {
    case 'inactive':
    case 'inactivo':
      return t('status_inactive', 'Invitado / Sin Clave (Pre-cargado)');
    case 'pending_approval':
    case 'pending approval':
    case 'pendiente':
      return t('status_pending_approval', 'Pendiente por Auditar');
    case 'requires_visit':
    case 'requiere visita':
      return t('status_requires_visit', 'Requiere Visita de Campo');
    case 'active':
    case 'activo':
      return t('status_active', 'Activo / Operativo');
    case 'disabled':
    case 'deshabilitado':
    case 'bloqueado':
      return t('status_disabled', 'Deshabilitado / Bloqueado');
    case 'rejected':
    case 'rechazado':
      return t('status_rejected', 'Rechazado / No Aprobado');
    case 'completed':
    case 'completado':
      return t('status_completed', 'Completado');
    case 'delivered':
    case 'entregado':
      return t('status_delivered', 'Entregado');
    case 'cancelled':
    case 'cancelado':
      return t('status_cancelled', 'Cancelado');
    default:
      return status;
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
